import { defineMessages } from 'react-intl';

const messages = defineMessages({
  coApplicantCreditCardPlaceholder: {
    id: 'rahalaitos.fi.coApplicantCreditCardPlaceholder',
    defaultMessage: 'Choose',
    description: 'coApplicant CreditCard Placeholder',
  },
  coApplicantHomeTypeCategoryDescriptionPlaceholder: {
    id: 'rahalaitos.fi.coApplicantHomeTypeCategoryDescriptionPlaceholder',
    defaultMessage: 'Choose',
    description: 'coApplicant HomeTypeCategory Placeholder',
  },
  currentLoansTotalWarning: {
    id: 'rahalaitos.fi.currentLoansTotalWarning',
    defaultMessage: 'Oupps, an update is needed! \n Seems like you are refinancing more than you are applying for. Please go to the beginning of the form and increase the total loan amount. Then you will be able to finalise your application.',
    description: 'current loans extended warning',
  },
  monthlyIncomeBeforeTaxTooltip: {
    id: 'rahalaitos.fi.monthlyIncomeBeforeTaxTooltip',
    defaultMessage: 'Please include here your main source of income and also any additional income you have, that can be proved through tax or payment slips. Including unverifiable income will diminish your chances of getting a loan.',
    description: 'monthly income before tax tooltip',
  },
  monthlyIncomeAfterTaxTooltip: {
    id: 'rahalaitos.fi.monthlyIncomeAfterTaxTooltip',
    defaultMessage: 'Please include here your main source of income and also any additional income you have, that can be proved through tax or payment slips. Including unverifiable income will diminish your chances of getting a loan.',
    description: 'monthly income before tax tooltip',
  },
  currentLoansDesc: {
    id: 'rahalaitos.fi.currentLoansDesc',
    defaultMessage: 'To ensure banks get accurate details and provide the best offer, you need to share information about all your current loans and credits. This is also where you select which loans to include in your consolidation and refinancing application.',
    description: 'current loans extended description',
  },
  currentLoansSumTitle: {
    id: 'rahalaitos.fi.currentLoansSumTitle',
    defaultMessage: 'Application summary',
    description: 'Application summary',
  },
  currentLoansSumTooltip: {
    id: 'rahalaitos.fi.currentLoansSumTooltip',
    defaultMessage: 'If you want to change your new loan amount - please change the total loan amount in the beginning of the form (Total loan amount = Refinance loans + new loan). If you want to change amount to be refinanced - please add/remove loans you want to refinance in the section above.',
    description: 'Application summary tooltip',
  },
  currentLoansSumNew: {
    id: 'rahalaitos.fi.currentLoansSumNew',
    defaultMessage: 'New loan',
    description: 'Application summary new loan label',
  },
  currentLoansSumRefinance: {
    id: 'rahalaitos.fi.currentLoansSumRefinance',
    defaultMessage: 'Refinance',
    description: 'Application summary refinance label',
  },
  currentLoansSumTotal: {
    id: 'rahalaitos.fi.currentLoansSumTotal',
    defaultMessage: 'Total applied for',
    description: 'Application summary refinance label',
  },
  otherLivingCostPlaceholder: {
    id: 'rahalaitos.fi.otherLivingCostPlaceholder',
    defaultMessage: 'E.g. € 500',
    description: 'Placeholder for other living cost',
  },
  coApplicantOtherLivingCostPlaceholder: {
    id: 'rahalaitos.fi.coApplicantOtherLivingCostPlaceholder',
    defaultMessage: 'E.g. € 500',
    description: 'Placeholder for other living cost',
  },
  creditCardPlaceholder: {
    id: 'rahalaitos.fi.creditCardPlaceholder',
    defaultMessage: 'Choose',
    description: 'Placeholder for asking customer if they have credit cards',
  },
  debtBreakdownLabel: {
    id: 'rahalaitos.fi.debtBreakdownLabel',
    defaultMessage: 'Current loans',
    description: 'Form header for current loans section',
  },
  loanTypeConsumer: {
    id: 'rahalaitos.fi.loanTypeConsumer',
    defaultMessage: 'Consumer',
    description: 'Option of loan types in current loans input',
  },
  loanTypeCar: {
    id: 'rahalaitos.fi.loanTypeCar',
    defaultMessage: 'Car',
    description: 'Option of loan types in current loans input',
  },
  loanTypeCreditCard: {
    id: 'rahalaitos.fi.loanTypeCreditCard',
    defaultMessage: 'CreditCard',
    description: 'Option of loan types in current loans input',
  },
  loanTypeMortgage: {
    id: 'rahalaitos.fi.loanTypeMortgage',
    defaultMessage: 'Mortgage',
    description: 'Option of loan types in current loans input',
  },
  loanTypeStudent: {
    id: 'rahalaitos.fi.loanTypeStudent',
    defaultMessage: 'Student',
    description: 'Option of loan types in current loans input',
  },
  coApplicantLoanAmountTooltip: {
    id: 'rahalaitos.fi.coApplicantLoanAmountTooltip',
    defaultMessage: 'Please provide the co-applicants current outstanding balance of this loan. Do not list any other debts in this field.',
    description: 'tooltip for co-applicants current loan total amount',
  },
  coApplicantLoanMonthlyCostTooltip: {
    id: 'rahalaitos.fi.coApplicantLoanMonthlyCostTooltip',
    defaultMessage: 'Please enter the co-applicants monthly installment for this loan. Do not list the costs of any other loans in this field',
    description: 'tooltip for co-applicants current loan total amount',
  },
  loanAmountTooltip: {
    id: 'rahalaitos.fi.loanAmountTooltip',
    defaultMessage: 'Please provide the current outstanding balance of this loan. Do not list any other debts in this field.',
    description: 'tooltip for current loan total amount',
  },
  loanMonthlyCostTooltip: {
    id: 'rahalaitos.fi.loanMonthlyCostTooltip',
    defaultMessage: 'Please enter the monthly installment for this loan. Do not list the costs of any other loans in this field',
    description: 'tooltip for current loan total amount',
  },
  loansSummary: {
    id: 'rahalaitos.fi.loansSummary',
    defaultMessage: 'Total amount to be refinanced',
    description: 'Label for showing sum of refinanced current loans',
  },
  loanAdd: {
    id: 'rahalaitos.fi.loanAdd',
    defaultMessage: 'Add loan',
    description: 'Label for adding a current loan',
  },
  loanRemoval: {
    id: 'rahalaitos.fi.loanRemoval',
    defaultMessage: 'Remove',
    description: 'Label for removing a current loan',
  },
  loanMonthlyCostLabel: {
    id: 'rahalaitos.fi.loanMonthlyCostLabel',
    defaultMessage: 'Monthly cost',
    description: 'Label for current loans Monthly cost',
  },
  loanAmountLabel: {
    id: 'rahalaitos.fi.loanAmountLabel',
    defaultMessage: 'Loan amount',
    description: 'Label for current loans Loan amount',
  },
  loanTransferLabel: {
    id: 'rahalaitos.fi.loanTransferLabel',
    defaultMessage: 'Would you like to refinance this loan?',
    description: 'Label for current loans transfer toggle',
  },
  loanTypeLabel: {
    id: 'rahalaitos.fi.loanTypeLabel',
    defaultMessage: 'Loan type',
    description: 'Label for current loans loan type',
  },
  coApplicantMonthlyIncomeAfterTaxRequired: {
    id: 'rahalaitos.fi.errorBoundary.coApplicantMonthlyIncomeAfterTaxRequired',
    defaultMessage: 'Please enter your co-applicants monthly income after tax(€/ mth)',
    description: 'The default error message when co applicants monthly income after tax is missing',
  },
  defaultErrorHeadline: {
    id: 'rahalaitos.fi.errorBoundary.defaultErrorHeadline',
    defaultMessage: 'Something went wrong!',
    description: 'The default error message when something has failed - Oops, something went wrong',
  },
  defaultErrorMessage: {
    id: 'rahalaitos.fi.errorBoundary.defaultErrorMessage',
    defaultMessage: 'We currently have technical problems. Please contact customer support for assistance or try again!',
    description: 'The default error message when something has failed - Oops, something went wrong',
  },
  defaultErrorMessageWithPhoneNumber: {
    id: 'rahalaitos.fi.errorBoundary.defaultErrorMessageWithPhoneNumber',
    defaultMessage: 'We currently have technical problems. Click the button below and we will call you as soon as we can on <i> {customerPhoneNumber} </i> to continue your application',
    description: 'The default error message when something has failed - Oops, something went wrong',
  },
  emailSubmissionInputPlaceholder: {
    id: 'rahalaitos.fi.errorBoundary.emailSubmissionInputPlaceholder',
    defaultMessage: 'Your eamil',
    description: 'The default input placeholder for Email Submissionform',
  },
  emailSubmissionButtonLabel: {
    id: 'rahalaitos.fi.errorBoundary.emailSubmissionButtonLabel',
    defaultMessage: 'Email Submission',
    description: 'The default button label for Email Submission form',
  },
  emailSubmissionSuccessMessage: {
    id: 'rahalaitos.fi.errorBoundary.emailSubmissionSuccessMessage',
    defaultMessage: 'Thank you!',
    description: 'Success message on the Email Submission-button in the form',
  },
  emailSubmissionErrorMessage: {
    id: 'rahalaitos.fi.errorBoundary.emailSubmissionErrorMessage',
    defaultMessage: 'We could not send email, please try again later!',
    description: 'Error message on the "Email Submission"-button in the form',
  },
  leadFormHeadline: {
    id: 'rahalaitos.fi.leadFormHeadline',
    defaultMessage: 'LOAN APPLICATION',
    description: 'Title at the top of the lead form',
  },
  leadFormSubHeader: {
    id: 'rahalaitos.fi.leadFormSubHeader',
    defaultMessage: 'Applying for a loan is free of charge and does not bind you to anything.',
    description: 'Sub header at the top of the lead form',
  },
  totalLoanUseOnlyNumbers: {
    id: 'rahalaitos.fi.totalLoanUseOnlyNumbers',
    defaultMessage: 'Use numbers please.',
    description: 'Informing the customer/applicant that only numbers are allowed for the total loan amount',
  },
  tooLowTotalLoan: {
    id: 'rahalaitos.fi.tooLowTotalLoan',
    defaultMessage: 'Lowest loan amount is {minAllowedAmount, number, currency}.',
    description: 'Informing the customer/applicant that they have provided a loan amount to low. Also show what the minimum loan amount is',
  },
  tooHighTotalLoan: {
    id: 'rahalaitos.fi.tooHighTotalLoan',
    defaultMessage: 'Highest loan amount is {maxAllowedAmount, number, currency}.',
    description: 'Informing the customer/applicant that they have provided a loan amount to high. Also show what the maximum loan amount is',
  },
  tooHighCurrentLoan: {
    id: 'rahalaitos.fi.tooHighCurrentLoan',
    defaultMessage: 'Highest loan amount is {maxLimit, number, currency}.',
    description: 'Error message informing the applicant that loan amount is to high',
  },
  textInputIsRequired: {
    id: 'rahalaitos.fi.textInputIsRequired',
    defaultMessage: 'This field can not be left empty',
    description: '',
  },
  buttonGroupIsRequired: {
    id: 'rahalaitos.fi.buttonGroupIsRequired',
    defaultMessage: 'Please select one.',
    description: 'Tells the customer that one option needs to be selected',
  },
  checkBoxIsRequired: {
    id: 'rahalaitos.fi.checkBoxIsRequired',
    defaultMessage: 'Please consent to our terms and conditions',
    description: 'Tells the customer that checkox needs to be checked',
  },
  repaymentTimeUseOnlyNumbers: {
    id: 'rahalaitos.fi.repaymentTimeUseOnlyNumbers',
    defaultMessage: 'Use numbers please.',
    description: 'Inform the customer that they are only allowed to use numbers',
  },
  tooShortRepaymentTime: {
    id: 'rahalaitos.fi.tooShortRepaymentTime',
    defaultMessage: 'Shortest possible repayment time is {loanMinYears} year.',
    description: 'Inform the customer that they have choosen a repayment time shorter than allowed',
  },
  tooLongRepaymentTime: {
    id: 'rahalaitos.fi.tooLongRepaymentTime',
    defaultMessage: 'Longest possible repayment time is {loanMaxYears} years.',
    description: 'Inform the customer thath they have choosen a repayment time further ahead than allowed',
  },
  purposeIsRequired: {
    id: 'rahalaitos.fi.purposeIsRequired',
    defaultMessage: 'Please choose a loan purpose.',
    description: 'Informing the customer that a cause/reason for the loan must be passed in',
  },
  numCurrentLoansIsRequired: {
    id: 'rahalaitos.fi.numCurrentLoansIsRequired',
    defaultMessage: 'Number of current loans are required.',
    description: 'Error message informing the applicant that the number of current loan must be provided',
  },
  numCurrentLoansUseOnlyNumbers: {
    id: 'rahalaitos.fi.numCurrentLoansUseOnlyNumbers',
    defaultMessage: 'Use numbers please.',
    description: 'Error message informing the applicant that only numbers are allowed',
  },
  tooLowNumCurrentLoans: {
    id: 'rahalaitos.fi.tooLowNumCurrentLoans',
    defaultMessage: 'Enter number of credits (0-10).',
    description: 'Error message informing the applicant that the number of current loans provided is to low',
  },
  tooHighNumCurrentLoans: {
    id: 'rahalaitos.fi.tooHighNumCurrentLoans',
    defaultMessage: 'Enter number of credits (0-10).',
    description: 'Error message informing the applicant that the number of current loands provided is to high',
  },
  newLoanUseOnlyNumbers: {
    id: 'rahalaitos.fi.newLoanUseOnlyNumbers',
    defaultMessage: 'Use numbers please.',
    description: 'Inform the customer/applicant that they are only allowed to use numbers',
  },
  tooLowNewLoan: {
    id: 'rahalaitos.fi.tooLowNewLoan',
    defaultMessage: 'Lowest loan amount is {minAllowedAmount, number, currency}.',
    description: 'When a customer/applicant has filled in an amount lower than minimum amount allowed',
  },
  tooHighNewLoan: {
    id: 'rahalaitos.fi.tooHighNewLoan',
    defaultMessage: 'Highest loan amount is {maxAllowedAmount, number, currency}.',
    description: 'When a customer/applicant has filled in an amount higher than maximum amount allowed',
  },
  mergeLoanUseOnlyNumbers: {
    id: 'rahalaitos.fi.mergeLoanUseOnlyNumbers',
    defaultMessage: 'Use numbers please.',
    description: 'Error message informing the applicant that only numbers are allowed to be provided',
  },
  tooLowMergeLoan: {
    id: 'rahalaitos.fi.tooLowMergeLoan',
    defaultMessage: 'Lowest loan amount is {minAllowedAmount, number, currency}.',
    description: 'Error message informing the applicant that the loan amount is to low and what the minimum requirements are',
  },
  tooHighMergeLoan: {
    id: 'rahalaitos.fi.tooHighMergeLoan',
    defaultMessage: 'Highest loan amount is {maxAllowedAmount, number, currency}.',
    description: 'Error message informing the applicant that the loan amount is to high and what the maximum requirements are',
  },
  mergeLoanIsNotABoolean: {
    id: 'rahalaitos.fi.mergeLoanIsNotABoolean',
    defaultMessage: 'Please choose if you want to consolidate loans',
    description: 'Error message informing that merge is not of type boolean',
  },
  interestRateUseOnlyNumbers: {
    id: 'rahalaitos.fi.interestRateUseOnlyNumbers',
    defaultMessage: 'Please use only numbers',
    description: 'Informing the customer/applicant that only numbers are allowed for the interest rate',
  },
  tooLowInterestRate: {
    id: 'rahalaitos.fi.tooLowInterestRate',
    defaultMessage: 'The lowest effective interest rate you can use is {minAllowedAmount} %.',
    description: 'Informing the customer/applicant that they have provided a interest rate to low. Also show what the minimum interest rate is',
  },
  tooHighInterestRate: {
    id: 'rahalaitos.fi.tooHighInterestRate',
    defaultMessage: 'The highest effective interest rate you can use is {maxAllowedAmount} %.',
    description: 'Informing the customer/applicant that they have provided a interest rate to high. Also show what the maximum interest rate is',
  },
  interestRateHasTwoDots: {
    id: 'rahalaitos.fi.interestRateHasTwoDots',
    defaultMessage: "Please check if you've added too many dots as separators",
    description: 'Informing the customer/applicant that they have...',
  },
  nothingBeforeDotInInterestRate: {
    id: 'rahalaitos.fi.nothingBeforeDotInInterestRate',
    defaultMessage: 'Please enter a number before the separator',
    description: 'Informing the customer/applicant that they have...',
  },
  tooManyDecimalsInInterestRate: {
    id: 'rahalaitos.fi.tooManyDecimalsInInterestRate',
    defaultMessage: "Please check if you've added too many decimals",
    description: 'Informing the customer/applicant that they have...',
  },
  homeTypeIsRequired: {
    id: 'rahalaitos.fi.homeTypeIsRequired',
    defaultMessage: 'Please enter a housing situation.',
    description: 'Error message informing applicant that a type of housing must be provided',
  },
  employmentTypeIsRequired: {
    id: 'rahalaitos.fi.employmentTypeIsRequired',
    defaultMessage: 'Please enter an employment type',
    description: 'Inform the customer that a employment type must be provided',
  },
  employedToMonthIsRequired: {
    id: 'rahalaitos.fi.employedToMonthIsRequired',
    defaultMessage: 'Month is required.',
    description: 'Error message informing the applicant that an "employed until"-month must be selected',
  },
  employedToRequiredYear: {
    id: 'rahalaitos.fi.employedToRequiredYear',
    defaultMessage: 'Year is required.',
    description: 'Error message informing the applicant that a year must be filled in for the field "employed untill the year of"',
  },
  employedToRequiredMonth: {
    id: 'rahalaitos.fi.employedToRequiredMonth',
    defaultMessage: 'Month is required.',
    description: 'Error message informing the applicant that a month must be filled in for the field "employed untill the month of',
  },
  employedToUseOnlyNumbers: {
    id: 'rahalaitos.fi.employedToUseOnlyNumbers',
    defaultMessage: 'Enter when your project employment ends, only digits (i.e. {nextYear}).',
    description: 'Error message informing the applicant that they need to fill in when their employment ends, only in numbers',
  },
  employedToFormat: {
    id: 'rahalaitos.fi.employedToFormat',
    defaultMessage: 'Enter the year with four digits (i.e. {nextYear})',
    description: 'Error message reminding the customer that the year needs to be in the correct format (xxxx)',
  },
  employedToDateIsInThePast: {
    id: 'rahalaitos.fi.employedToDateIsInThePast',
    defaultMessage: 'The end date must be a future date.',
    description: 'Error message informing the applicant that the choosen date was set to a date in the past',
  },
  employedToDateTooFarInTheFuture: {
    id: 'rahalaitos.fi.employedToDateTooFarInTheFuture',
    defaultMessage: 'The end date is too far in the future',
    description: 'Error message informing the applicant that the choosen date that is more than 100 years in the future',
  },
  employedSinceMonthRequired: {
    id: 'rahalaitos.fi.employedSinceMonthRequired',
    defaultMessage: 'Month is required.',
    description: 'Error message informing the applicant that an "employed since"-month must be selected',
  },
  requiredDependants: {
    id: 'rahalaitos.fi.requiredDependants',
    defaultMessage: 'Please enter number of children.',
    description: 'Error message informing the applicant that the number of dependants/kids havent been filled in',
  },
  dependantsUseOnlyNumbers: {
    id: 'rahalaitos.fi.dependantsUseOnlyNumbers',
    defaultMessage: 'Use numbers please.',
    description: 'Error message informing the applicant that they may only use numbers when filling in the number of dependants/kids',
  },
  tooLowDependants: {
    id: 'rahalaitos.fi.tooLowDependants',
    defaultMessage: 'Enter number of children.',
    description: 'Error message informing the applicant that they have filled in a too low of an amount of dependants',
  },
  tooHighDependants: {
    id: 'rahalaitos.fi.tooHighDependants',
    defaultMessage: 'Enter number of children.',
    description: 'Error message informing the applicant that they have filled in a too high of an amount of dependants',
  },
  consolidateLoanUseOnlyNumber: {
    id: 'rahalaitos.fi.consolidateLoanUseOnlyNumber',
    defaultMessage: 'Use numbers please.',
    description: 'Asking the customer/applicant to only use numbers for the input',
  },
  tooHighConsolidateLoan: {
    id: 'rahalaitos.fi.tooHighConsolidateLoan',
    defaultMessage: 'Highest loan amount is {maxAllowedAmount, number, currency}.',
    description: 'Informing the customer/applicant that they have entered a loan amount to high. Also shows the max allowed amount',
  },
  requiredCivilStatus: {
    id: 'rahalaitos.fi.requiredCivilStatus',
    defaultMessage: 'Please enter a martial status.',
    description: 'Error message informing the applicant that their civil state must be provided',
  },
  phoneNumberMobilePrefixError: {
    id: 'rahalaitos.fi.phoneNumberMobilePrefixError',
    defaultMessage: 'Your phone number must begin with 0, +358 or 00358.',
    description: '',
  },
  wrongPhoneNumberNumber: {
    id: 'rahalaitos.fi.wrongPhoneNumberNumber',
    defaultMessage: 'The phone number appears to be incorrect. Please enter a valid Finnish mobile phone number.',
  },
  wrongPhoneNumberBeginning: {
    id: 'rahalaitos.fi.wrongPhoneNumberBeginning',
    defaultMessage: "The phone number is too long. Verify that you haven't added a digit too many",
    description: 'Error message for when the customer fills in a too long phone number.',
  },
  missingOccupation: {
    id: 'rahalaitos.fi.missingOccupation',
    defaultMessage: 'Please enter your occupation',
    description: 'Error message',
  },
  requiredNationalId: {
    id: 'rahalaitos.fi.requiredNationalId',
    defaultMessage: 'A national ID is required.',
    description: 'Error message informing the applicant that a social security number/national ID must be provided',
  },
  wrongNationalIdFormat: {
    id: 'rahalaitos.fi.wrongNationalIdFormat',
    defaultMessage: 'Wrong format, for example: 131159-2950.',
    description: 'Error message informing the applicant that the social security number/national ID is wrongly formatted',
  },
  tooYoungNationalId: {
    id: 'rahalaitos.fi.tooYoungNationalId',
    defaultMessage: 'You have to be at least {minAge} years of age to submit an application.',
    description: 'Error message informing the applicant that the applicant/customer has provided an age to low required to make an application',
  },
  tooOldNationalId: {
    id: 'rahalaitos.fi.tooOldNationalId',
    defaultMessage: 'Unfortunately, we can only help people up to {maxAge} years of age.',
    description: 'Error message informing the applicant that the applicant/customer has provided an age to high required to make an application',
  },
  invalidNationalId: {
    id: 'rahalaitos.fi.invalidNationalId',
    defaultMessage: 'Invalid national ID.',
    description: 'Error message informing the applicant that the social security number/national ID is invalid',
  },
  employerPhoneMissingPhoneNumber: {
    id: 'rahalaitos.fi.employerPhoneMissingPhoneNumber',
    defaultMessage: 'Please enter a phone number',
    description: '',
  },
  requiredBankAccount: {
    id: 'rahalaitos.fi.requiredBankAccount',
    defaultMessage: 'Bank account number is required.',
    description: 'Error message informing the applicant that a bank account number must be provided',
  },
  invalidBankAccountFormat: {
    id: 'rahalaitos.fi.invalidBankAccountFormat',
    defaultMessage: 'Wrong format.',
    description: 'Error message informing the applicant that the bank account number is wrongly formatted',
  },
  invalidBankAccount: {
    id: 'rahalaitos.fi.invalidBankAccount',
    defaultMessage: 'Invalid bank account number',
    description: 'Error message informing the applicant that the bank account number is invalid',
  },
  unemployedSinceDynamicLabel: {
    id: 'rahalaitos.fi.unemployedSinceDynamicLabel',
    defaultMessage: 'Unemployed since',
    description: 'Dynamic label for employed since',
  },
  houseLoanAmountTooltip: {
    id: 'rahalaitos.fi.houseLoanAmountTooltip',
    defaultMessage: 'Please enter the current amount of debt tied to your house loan/loans. Do not list other debts in this field.',
    description: '',
  },
  studentLoanAmountTooltip: {
    id: 'rahalaitos.fi.studentLoanAmountTooltip',
    defaultMessage: 'Please enter the current amount of debt tied to your student loan/loans. Do not list other debts in this field.',
    description: '',
  },
  creditLoanAmountTooltip: {
    id: 'rahalaitos.fi.creditLoanAmountTooltip',
    defaultMessage: 'Please enter the current amount of debt tied to your credit card loan/loans. Do not list other debts in this field.',
    description: '',
  },
  privateLoanAmountTooltip: {
    id: 'rahalaitos.fi.privateLoanAmountTooltip',
    defaultMessage: 'Please enter the current amount of debt tied to your consumer loan/loans. Do not list other debts in this field.',
    description: '',
  },
  coApplicantPrivateLoansAmountTooltip: {
    id: 'rahalaitos.fi.coApplicantPrivateLoansAmountTooltip',
    defaultMessage: 'Please enter the current amount of debt tied to co-applicants consumer loan/loans. Do not list other debts in this field.',
    description: '',
  },
  coApplicantCarLoansAmountTooltip: {
    id: 'rahalaitos.fi.coApplicantCarLoansAmountTooltip',
    defaultMessage: 'Please enter the current amount of debt tied to co-applicants car loan/loans. Do not list other debts in this field.',
    description: '',
  },
  coApplicantHouseLoansAmountTooltip: {
    id: 'rahalaitos.fi.coApplicantHouseLoansAmountTooltip',
    defaultMessage: 'Please enter the current amount of debt tied to co-applicants house loan/loans. Do not list other debts in this field.',
    description: '',
  },
  coApplicantStudentLoansAmountTooltip: {
    id: 'rahalaitos.fi.coApplicantStudentLoansAmountTooltip',
    defaultMessage: 'Please enter the current amount of debt tied to co-applicants student loan/loans. Do not list other debts in this field.',
    description: '',
  },
  coApplicantCreditCardLoansAmountTooltip: {
    id: 'rahalaitos.fi.coApplicantCreditCardLoansAmountTooltip',
    defaultMessage: 'Please enter the current amount of debt tied to co-applicants credit card loan/loans. Do not list other debts in this field.',
    description: '',
  },
  houseLoanMonthlyCostTooltip: {
    id: 'rahalaitos.fi.houseLoanMonthlyCostTooltip',
    defaultMessage: 'Please enter the monthly cost for your house loan/loans. Do not list other costs in this field.',
    description: '',
  },
  studentLoanMonthlyCostTooltip: {
    id: 'rahalaitos.fi.studentLoanMonthlyCostTooltip',
    defaultMessage: 'Please enter the monthly cost for your student loan/loans. Do not list other costs in this field.',
    description: '',
  },
  creditLoanMonthlyCostTooltip: {
    id: 'rahalaitos.fi.creditLoanMonthlyCostTooltip',
    defaultMessage: 'Please enter the monthly cost for your credit loan/loans. Do not list other costs in this field.',
    description: '',
  },
  privateLoanMonthlyCostTooltip: {
    id: 'rahalaitos.fi.privateLoanMonthlyCostTooltip',
    defaultMessage: 'Please enter the monthly cost for your consumer loan/loans. Do not list other costs in this field.',
    description: '',
  },
  carLoansMonthlyCostTooltip: {
    id: 'rahalaitos.fi.carLoansMonthlyCostTooltip',
    defaultMessage: 'Please enter the monthly cost for your car loan/loans. Do not list other costs in this field.',
    description: '',
  },
  coApplicantPrivateLoansMonthlyCostTooltip: {
    id: 'rahalaitos.fi.coApplicantPrivateLoansMonthlyCostTooltip',
    defaultMessage: 'Please enter the monthly cost for co-applicants consumer loan/loans. Do not list other costs in this field.',
    description: '',
  },
  coApplicantCarLoansMonthlyCostTooltip: {
    id: 'rahalaitos.fi.coApplicantCarLoansMonthlyCostTooltip',
    defaultMessage: 'Please enter the monthly cost for co-applicants car loan/loans. Do not list other costs in this field.',
    description: '',
  },
  coApplicantHouseLoansMonthlyCostTooltip: {
    id: 'rahalaitos.fi.coApplicantHouseLoansMonthlyCostTooltip',
    defaultMessage: 'Please enter the monthly cost for co-applicants house loan/loans. Do not list other costs in this field.',
    description: '',
  },
  coApplicantStudentLoansMonthlyCostTooltip: {
    id: 'rahalaitos.fi.coApplicantStudentLoansMonthlyCostTooltip',
    defaultMessage: 'Please enter the monthly cost for co-applicants student loan/loans. Do not list other costs in this field.',
    description: '',
  },
  coApplicantCreditCardLoansMonthlyCostTooltip: {
    id: 'rahalaitos.fi.coApplicantCreditCardLoansMonthlyCostTooltip',
    defaultMessage: 'Please enter the monthly cost for co-applicants credit loan/loans. Do not list other costs in this field.',
    description: '',
  },
  isPepTooltip: {
    id: 'rahalaitos.fi.isPepTooltip',
    defaultMessage: 'Please enter yes if you or anyone close to you are a person in a Politically Exposed Position. PEP is a person who has/had important public functions in a state/international organization. E.g. Head of state, head of government, ministers, deputy or assistant minister or members of parliaments.',
    description: 'Tooltip for politically exposed',
  },
  creditCardTooltip: {
    id: 'rahalaitos.fi.creditCardTooltip',
    defaultMessage: 'Do you have any active credit cards?',
    description: 'Tooltip regarding having credit card or not',
  },
  houseLoanTooltip: {
    id: 'rahalaitos.fi.houseLoanTooltip',
    defaultMessage: 'Please enter the current debt of your mortgage. House loans/mortgages are loans used for financing the purchase of a property. These are loans that have the property itself as security. The banks and lenders need this information to get an overview of your financial situation and to be able to give out loan offers. Do not specify other debts in this field.',
    description: 'Tooltip regarding filling in current house loans',
  },
  studentLoanTooltip: {
    id: 'rahalaitos.fi.studentLoanTooltip',
    defaultMessage: 'Please enter the current debt of your student loan. The banks and lenders need this information to get an overview of your financial situation and to be able to give out loan offers. Do not specify other debts in this field.',
    description: 'Tooltip regarding filling in current student loans',
  },
  carLoanTooltip: {
    id: 'rahalaitos.fi.carLoanTooltip',
    defaultMessage: 'Please specify if you have loans to finance purchases of vehicles and have the vehicle itself as security for the loan. The banks and lenders need this information to get an overview of your financial situation and to be able to give out loan offers. Do not specify other debts in this field.',
    description: 'Tooltip regarding filling in current car loans',
  },
  carLoanAmountTooltip: {
    id: 'rahalaitos.fi.carLoanAmountTooltip',
    defaultMessage: 'Please enter the current amount of debt tied to your car loan/loans. Do not list other debts in this field.',
    description: 'Tooltip regarding filling in current car loans',
  },
  creditLoanTooltip: {
    id: 'rahalaitos.fi.creditLoanTooltip',
    defaultMessage: 'Please enter the current debt of your credit card/cards. The banks and lenders need this information to get an overview of your financial situation and to be able to give out loan offers. Do not specify other debts in this field.',
    description: 'Tooltip regarding filling in current credit loans',
  },
  privateLoanTooltip: {
    id: 'rahalaitos.fi.privateLoanTooltip',
    defaultMessage: 'Please enter your current debt for consumer/private loan/loans. Consumer loans are loans without security that can be used for anything - usually for consumption, renovation or paying other expensive debts. The banks and lenders need this information to get an overview of their financial situation and to be able to give out loan offers. Do not specify other debts in this field.',
    description: 'Tooltip regarding filling in current private loans',
  },
  currentLoansInformation: {
    id: 'rahalaitos.fi.currentLoansInformation',
    defaultMessage: 'NOTE: Please only list the specific loans we are asking for. Any other loans are not relevant at this stage and might be asked at a later stage if necessary.',
    description: 'Information regarding filling in current loans',
  },
  coApplicantHomeCostTooltip: {
    id: 'rahalaitos.fi.coApplicantHomeCostTooltip',
    defaultMessage: 'Please enter the monthly cost connected to your housing. This can consist of rent/fee, heat, water, electricity, insurance etc. If you are several who split the cost, enter your share only (e.g. half the total cost). NOTE: this does not include mortgage/loan costs.',
    description: 'Tooltip for coApplicant home cost field',
  },
  coApplicantHomeTypeTooltip: {
    id: 'rahalaitos.fi.coApplicantHomeTypeTooltip',
    defaultMessage: 'If your co-applicant has several types of housing - choose the type of housing in which they are currently registered.',
    description: 'Tooltip for coApplicant home type field',
  },
  coApplicantMonthlyIncomeBeforeTaxTooltip: {
    id: 'rahalaitos.fi.coApplicantMonthlyIncomeBeforeTaxTooltip',
    defaultMessage: 'Please include here your main source of income and also any additional income you have, that can be proved through tax or payment slips. Including unverifiable income will diminish your chances of getting a loan.',
    description: 'Tooltip for coApplicant income field',
  },
  coApplicantMonthlyIncomeAfterTaxTooltip: {
    id: 'rahalaitos.fi.coApplicantMonthlyIncomeAfterTaxTooltip',
    defaultMessage: 'Please include here your main source of income and also any additional income you have, that can be proved through tax or payment slips. Including unverifiable income will diminish your chances of getting a loan.',
    description: 'Tooltip for coApplicant income field',
  },
  coApplicantEmailTooltip: {
    id: 'rahalaitos.fi.coApplicantEmailTooltip',
    defaultMessage: "We need your co-applicant's email address to contact them regarding the loan application. If the co-applicant does not have an email address, you can contact customer service on 0942456000",
    description: 'Tooltip for coApplicant email field',
  },
  coApplicantPhoneNumberTooltip: {
    id: 'rahalaitos.fi.coApplicantPhoneNumberTooltip',
    defaultMessage: "We need your co-applicant's phone number to contact them regarding the loan application.",
    description: 'Tooltip for coApplicant phone number field',
  },
  occupancyTooltip: {
    id: 'rahalaitos.fi.occupancyTooltip',
    defaultMessage: 'Please enter your occupation in this field, e.g. a nurse, salesperson, or a cook.',
    description: 'Tooltip for applicant occupation field',
  },
  nationalIdTooltip: {
    id: 'rahalaitos.fi.nationalIdTooltip',
    defaultMessage: 'We need to verify your social security number to process your application.This needs to be a Finnish social security number.',
    description: 'Tooltip for applicant email field',
  },
  emailTooltip: {
    id: 'rahalaitos.fi.emailTooltip',
    defaultMessage: 'We need your email address to contact you regarding the loan application. If you do not have an email address, you can contact customer service on 0942456000',
    description: 'Tooltip for applicant email field',
  },
  phoneNumberTooltip: {
    id: 'rahalaitos.fi.phoneNumberTooltip',
    defaultMessage: 'We need your phone number to contact you regarding the loan application.',
    description: 'Tooltip for applicant phone number field',
  },
  businessOrganizationNumberTooltip: {
    id: 'rahalaitos.fi.businessOrganizationNumberTooltip',
    defaultMessage: 'Please enter your 7 digit business organization number/business identity code. For e.g. 000000-0. You can find this information from the Tax Administration or from the Finnish Trade Register (PRH)',
    description: 'tooltip for entering business organizational number if self employed',
  },
  coApplicantEmployedToTooltip: {
    id: 'rahalaitos.fi.coApplicantEmployedToTooltip',
    defaultMessage: 'Please enter when their employment ends.',
    description: 'Tooltip for coApplicant "employed until"-input, placed inside form',
  },
  employedToTooltip: {
    id: 'rahalaitos.fi.employedToTooltip',
    defaultMessage: 'Please enter when your employment ends.',
    description: 'Tooltip for "employed until"-input, placed inside form',
  },
  repaymentTimeTooltip: {
    id: 'rahalaitos.fi.repaymentTimeTooltip',
    defaultMessage: 'For how long do you want to repay the loan? The longer the period, the lower your monthly cost will be. You can always repay the loan faster without extra costs if you want to.',
    description: 'Tooltip for repayment time inside form, asking the applicant to fill in how long they wish to take to repay their loan. Also informing them that the longer time of repayment, the lower the monthly cost. ',
  },
  addCoApplicantDesc: {
    id: 'rahalaitos.fi.addCoApplicantDesc',
    defaultMessage: 'Adding a co-applicant often gives you an increased chance of getting a loan, and often at a better interest rate than without a co-applicant!',
    description: 'Description in add co-applicant textbox',
  },
  addCoApplicantTooltip: {
    id: 'rahalaitos.fi.addCoApplicantTooltip',
    defaultMessage: 'Co-applicants can provide the banks with better security as it is deemed a lower risk for the banks when two people apply for the loan. This can give more favorable terms and interest rates for the applicant(s), depending on your financial situation.',
    description: 'Tooltip for adding co-applicant',
  },
  purposeTooltip: {
    id: 'rahalaitos.fi.purposeTooltip',
    defaultMessage: 'If you have more than one purpose for the loan, state the main purpose. "Services" can be weddings, parties or cleaning services etc.',
    description: 'Tooltip for The purpose of the loan',
  },
  civilStatusTooltip: {
    id: 'rahalaitos.fi.civilStatusTooltip',
    defaultMessage: 'Please enter your relationship status. If you are living separately from your partner, use the option "Single".',
    description: 'Tooltip-text civilstånd i formulär.',
  },
  coApplicantCivilStatusTooltip: {
    id: 'rahalaitos.fi.coApplicantCivilStatusTooltip',
    defaultMessage: 'Please enter the relationship status of your co-applicant. If he/she is living separately from their partner, use the option "Single".',
    description: 'Tooltip-text for coApplicant civil status in form.',
  },
  applicationLoanAmountTooltip: {
    id: 'rahalaitos.fi.applicationLoanAmountTooltip',
    defaultMessage: 'Please enter the amount you would like to apply for.',
    description: 'Tooltip-text for total loan amount the customer wishes to apply for.',
  },
  currentLoanMergeTooltip: {
    id: 'rahalaitos.fi.currentLoanMergeTooltip',
    defaultMessage: 'Our partners can give you a more favorable interest rate if you choose to consolidate your loans. This way, they "buy out" parts or your whole loan situation and therefore merging them into a single loan.',
    description: 'Tooltip-text för val av att lösa lån i formulär.',
  },
  dependantsTooltip: {
    id: 'rahalaitos.fi.dependantsTooltip',
    defaultMessage: 'Please enter the number of children living at home who are under 21 years old.',
    description: 'Tooltip-text för antal barn i formulär.',
  },
  coApplicantDependantsTooltip: {
    id: 'rahalaitos.fi.coApplicantDependantsTooltip',
    defaultMessage: "Please enter the number of children living at your co-applicant's home who are under 21 years old.",
    description: 'Tooltip-text for coApplicant dependants in form.',
  },
  employerNameTooltip: {
    id: 'rahalaitos.fi.employerNameTooltip',
    defaultMessage: 'Please enter the name of the workplace you currently work at. If you have several employers, write the one you consider to be your main one.',
    description: 'Tooltip-text för företagsnamn i formulär.',
  },
  coApplicantEmployerNameTooltip: {
    id: 'rahalaitos.fi.coApplicantEmployerNameTooltip',
    defaultMessage: 'Please enter the name of the workplace your co-applicant is currently working for. If they have several employers, write the one that would be considered the main one.',
    description: 'Tooltip-text for coApplicant company name in form.',
  },
  coApplicantEmployerPhoneTooltip: {
    id: 'rahalaitos.fi.coApplicantEmployerPhoneTooltip',
    defaultMessage: "Your co-applicant's employer phone number can make it easier for our partners if they need additional information when considering providing a loan proposal.",
    description: 'Tooltip-text for coApplicant employer phone number in form.',
  },
  employmentTypeTooltip: {
    id: 'rahalaitos.fi.employmentTypeTooltip',
    defaultMessage: 'Please select your employment type. If you are on leave, choose the employment option from which you got your leave. If you have several jobs, please select the one that you consider as your main one. The choice "Pensioner" also includes early retirees.',
    description: 'Tooltip-text för sysselsättning i formulär.',
  },
  coApplicantEmploymentTypeTooltip: {
    id: 'rahalaitos.fi.coApplicantEmploymentTypeTooltip',
    defaultMessage: "Please select your co-applicant's employment type. If they are on leave, choose the employment option from which they got their leave. If they have several jobs, please select the one that is considered the main one. The choice ''Pensioner'' also includes early retirees.",
    description: 'Tooltip-text for coApplicant employment in form.',
  },
  employmentSinceMonthTooltip: {
    id: 'rahalaitos.fi.employmentSinceMonthTooltip',
    defaultMessage: "Please select approximately the year that you started at your current job. If you don't know exactly, pick what you think it is.",
    description: 'Tooltip for "employment since"-input',
  },
  employmentSinceYearTooltip: {
    id: 'rahalaitos.fi.employmentSinceYearTooltip',
    defaultMessage: 'Please enter approximately the year when you started at your current job. Use 4 numbers, e.g "2002".',
    description: 'Tooltip for "employment since"-input',
  },
  retiredEmploymentSinceTooltip: {
    id: 'rahalaitos.fi.retiredEmploymentSinceTooltip',
    defaultMessage: 'Please enter approximately when you retired.',
    description: '',
  },
  coApplicantRetiredEmploymentSinceTooltip: {
    id: 'rahalaitos.fi.coApplicantRetiredEmploymentSinceTooltip',
    defaultMessage: 'Please enter approximately when your co-applicant retired.',
    description: 'Tooltip-text for coApplicant retired since in form.',
  },
  homeCostTooltip: {
    id: 'rahalaitos.fi.homeCostTooltip',
    defaultMessage: 'Please enter the monthly cost connected to your housing. This can consist of rent/fee, heat, water, electricity, insurance etc. If you are several who split the cost, enter your share only (e.g. half the total cost). NOTE: this does not include mortgage/loan costs.',
    description: 'Tooltip-text för boendekostnad i formulär.',
  },
  homeTypeTooltip: {
    id: 'rahalaitos.fi.homeTypeTooltip',
    defaultMessage: 'If you have several addresses, please choose the one where you live today. "Own apartment" is considered bought apartments in housing cooperatives.',
    description: 'Tooltip-text för boendeform i formulär.',
  },
  loanPurposeTooltip: {
    id: 'rahalaitos.fi.loanPurposeTooltip',
    defaultMessage: 'Please specify what you want to use the loan for. If the option is not in the list, pick the one that is the closest.',
    description: 'Tooltip-text för lånets syfte i formulär.',
  },
  monthlyIncomeAfterTaxPlaceholder: {
    id: 'rahalaitos.fi.monthlyIncomeAfterTaxPlaceholder',
    defaultMessage: 'X XXX',
    description: 'Placeholder for applicant monthly income after tax inside form',
  },
  monthlyIncomeAfterTaxLabel: {
    id: 'rahalaitos.fi.monthlyIncomeAfterTaxLabel',
    defaultMessage: 'Monthly income + other verifiable income, after tax (€/mth)',
    description: 'Label for applicant monthly income after tax inside form',
  },
  monthlyIncomeBeforeTaxPlaceholder: {
    id: 'rahalaitos.fi.monthlyIncomeBeforeTaxPlaceholder',
    defaultMessage: 'X XXX',
    description: 'Placeholder for applicant monthly income before tax inside form',
  },
  monthlyIncomeBeforeTaxLabel: {
    id: 'rahalaitos.fi.monthlyIncomeBeforeTaxLabel',
    defaultMessage: 'Monthly income + other verifiable income, before tax (€/mth)',
    description: 'Label for applicant monthly income before tax inside form',
  },
  coApplicantMonthlyIncomeAfterTaxPlaceholder: {
    id: 'rahalaitos.fi.coApplicantMonthlyIncomeAfterTaxPlaceholder',
    defaultMessage: 'X XXX',
    description: 'Placeholder for coApplicant monthly income after tax inside form',
  },
  coApplicantMonthlyIncomeAfterTaxLabel: {
    id: 'rahalaitos.fi.coApplicantMonthlyIncomeAfterTaxLabel',
    defaultMessage: "Co-applicant's monthly income after taxes (€/mth)",
    description: 'Label for coApplicant monthly income after tax inside form',
  },
  coApplicantMonthlyIncomeBeforeTaxPlaceholder: {
    id: 'rahalaitos.fi.coApplicantMonthlyIncomeBeforeTaxPlaceholder',
    defaultMessage: 'X XXX',
    description: 'Placeholder for coApplicant monthly income before tax inside form',
  },
  coApplicantMonthlyIncomeBeforeTaxLabel: {
    id: 'rahalaitos.fi.coApplicantMonthlyIncomeBeforeTaxLabel',
    defaultMessage: 'Co-applicant’s monthly income before taxes (€/mth)',
    description: 'Label for coApplicant monthly income before tax inside form',
  },
  coApplicantEmployedToYearPlaceholder: {
    id: 'rahalaitos.fi.coApplicantEmployedToYearPlaceholder',
    defaultMessage: 'Year',
    description: 'Default text for coApplicant "employed until"-input in years, placed inside form',
  },
  coApplicantEmployedToYearLabel: {
    id: 'rahalaitos.fi.coApplicantEmployedToYearLabel',
    defaultMessage: 'Co-applicant employed until (year)',
    description: 'Label for coApplicant "employed until"-input in years, placed inside form',
  },
  coApplicantEmployedToMonthLabel: {
    id: 'rahalaitos.fi.coApplicantEmployedToMonthLabel',
    defaultMessage: 'Co-applicant employed until (month)',
    description: 'Default text for coApplicant "employed until"-input in months, placed inside form',
  },
  coApplicantEmployedToMonthPlaceholder: {
    id: 'rahalaitos.fi.coApplicantEmployedToMonthPlaceholder',
    defaultMessage: 'Month',
    description: 'Default text for coApplicant "employed until"-input in months, placed inside form',
  },
  employedToMonthLabel: {
    id: 'rahalaitos.fi.employedToMonthLabel',
    defaultMessage: 'Employed until (month)',
    description: 'Default text for "employed until"-input in months, placed inside form',
  },
  employedToYearPlaceholder: {
    id: 'rahalaitos.fi.employedToYearPlaceholder',
    defaultMessage: 'Year',
    description: 'Default text for "employed until"-input in years, placed inside form',
  },
  employedToYearLabel: {
    id: 'rahalaitos.fi.employedToYearLabel',
    defaultMessage: 'Employed until (year)',
    description: 'Label for "employed until"-input in years, placed inside form',
  },
  employedToMonthPlaceholder: {
    id: 'rahalaitos.fi.employedToMonthPlaceholder',
    defaultMessage: 'Month',
    description: 'Default text for "employed until"-input in months, placed inside form',
  },
  retiredSinceDynamicLabel: {
    id: 'rahalaitos.fi.retiredSinceDynamicLabel',
    defaultMessage: 'Retired since',
    description: 'Dynamic label for employedSinceYear',
  },
  disabilityPensionSinceDynamicLabel: {
    id: 'rahalaitos.fi.disabilityPensionSinceDynamicLabel',
    defaultMessage: 'Disability pensioner since',
    description: 'Dynamic label for employedSinceYear',
  },
  employedSinceMonthplaceholder: {
    id: 'rahalaitos.fi.employedSinceMonthplaceholder',
    defaultMessage: 'Month',
    description: 'Default text for "employed since"-input in months, placed inside form',
  },
  nextSlide: {
    id: 'rahalaitos.fi.nextSlide',
    defaultMessage: 'Next',
    description: 'general progress button label',
  },
  slideTitleOne: {
    id: 'rahalaitos.fi.slideTitleOne',
    defaultMessage: 'Your details',
    description: 'First slide title',
  },
  slideTitleTwo: {
    id: 'rahalaitos.fi.slideTitleTwo',
    defaultMessage: 'Employment',
    description: '',
  },
  slideTitleThree: {
    id: 'rahalaitos.fi.slideTitleThree',
    defaultMessage: 'Housing',
    description: '',
  },
  slideTitleFour: {
    id: 'rahalaitos.fi.slideTitleFour',
    defaultMessage: 'Loans',
    description: '',
  },
  slideTitleFive: {
    id: 'rahalaitos.fi.slideTitleFive',
    defaultMessage: "Co-applicant's details",
    description: '',
  },
  spouseMonthlyIncomeLabel: {
    id: 'rahalaitos.fi.spouseMonthlyIncomeLabel',
    defaultMessage: "Spouse's monthly income before taxes (€/mth)",
    description: 'Label for spouse monthly income field',
  },
  spouseMonthlyIncomePlaceholder: {
    id: 'rahalaitos.fi.spouseMonthlyIncomePlaceholder',
    defaultMessage: "Spouse's monthly income before taxes (€/mth)",
    description: 'Placeholder for spouse monthly income field',
  },
  spouseMonthlySalaryBeforeTaxRequired: {
    id: 'rahalaitos.fi.spouseMonthlySalaryBeforeTaxRequired',
    defaultMessage: "Spouse's monthly income before tax is required",
    description: 'Error message for not filling in spouse monthly income',
  },
  spouseMonthlySalaryOnlynumbers: {
    id: 'rahalaitos.fi.spouseMonthlySalaryOnlynumbers',
    defaultMessage: 'Please write your spouse income in numbers only',
    description: 'Error message for only allowed to use numbers',
  },
  spouseMonthlySalaryMustBePositive: {
    id: 'rahalaitos.fi.spouseMonthlySalaryMustBePositive',
    defaultMessage: "Your spouse's monthly income can not be negative",
    description: 'Error message for only allowed to use numbers',
  },
  repaymentTimePlaceholder: {
    id: 'rahalaitos.fi.repaymentTimePlaceholder',
    defaultMessage: '0',
    description: 'Default text for repayment time inside form',
  },
  repaymentTimeLabel: {
    id: 'rahalaitos.fi.repaymentTimeLabel',
    defaultMessage: 'Repayment time',
    description: 'Label for repayment time inside form',
  },
  repaymentTimeSuffix: {
    id: 'rahalaitos.fi.repaymentTimeSuffix',
    defaultMessage: 'years',
    description: 'Suffix for repayment time inside form',
  },
  addCoApplicantLabel: {
    id: 'rahalaitos.fi.addCoApplicantLabel',
    defaultMessage: 'Do you want to increase your chances of receiving more favorable offers by adding a co-applicant?',
    description: 'Experiment-variant for add co-applicant option that the applicant can use if they wish to share their loan with a co-applicant',
  },
  purposeHeaderText: {
    id: 'rahalaitos.fi.purposeHeaderText',
    defaultMessage: 'Credit purpose',
    description: 'Header in the application form for the group of loan purpose related inputs - The purpose of the loan',
  },
  purposeHeaderPlaceholder: {
    id: 'rahalaitos.fi.purposeHeaderPlaceholder',
    defaultMessage: 'Choose',
    description: 'Placeholder for the loan purpose inputs',
  },
  civilStatusLabel: {
    id: 'rahalaitos.fi.civilStatusLabel',
    defaultMessage: 'Marital status',
    description: 'Label-text för civilstånd i formulär.',
  },
  civilStatusPlaceholder: {
    id: 'rahalaitos.fi.civilStatusPlaceholder',
    defaultMessage: 'Choose',
    description: 'Placeholder for civil status field',
  },
  civilStatusSingle: {
    id: 'rahalaitos.fi.civilStatusSingle',
    defaultMessage: 'Single',
    description: 'Marital status of the applicant - single',
  },
  civilStatusPartner: {
    id: 'rahalaitos.fi.civilStatusPartner',
    defaultMessage: 'Cohabitant',
    description: 'Marital status of the applicant - partner',
  },
  civilStatusMarried: {
    id: 'rahalaitos.fi.civilStatusMarried',
    defaultMessage: 'Married',
    description: 'Marital status of the applicant - married',
  },
  coApplicantCivilStatusLabel: {
    id: 'rahalaitos.fi.coApplicantCivilStatusLabel',
    defaultMessage: 'Marital status of co-applicant',
    description: 'Label for civil status of co-applicant',
  },
  coApplicantCivilStatusPlaceholder: {
    id: 'rahalaitos.fi.coApplicantCivilStatusPlaceholder',
    defaultMessage: 'Choose',
    description: 'Placeholder for civil status of co-applicant',
  },
  applicationLoanAmountPlaceholder: {
    id: 'rahalaitos.fi.applicationLoanAmountPlaceholder',
    defaultMessage: 'X XXX',
    description: 'Default-text för totalbelopp av ett nuvarande kreditlån i formulär.',
  },
  applicationLoanAmountLabel: {
    id: 'rahalaitos.fi.applicationLoanAmountLabel',
    defaultMessage: 'Loan amount',
    description: 'Label-text för totalbelopp av ett nuvarande kreditlån i formulär.',
  },
  applicationLoanAmountSuffix: {
    id: 'rahalaitos.fi.applicationLoanAmountSuffix',
    defaultMessage: '€',
    description: 'Suffix-text för totalbelopp av ett nuvarande kreditlån i formulär.',
  },
  currentLoanMergeLabel: {
    id: 'rahalaitos.fi.currentLoanMergeLabel',
    defaultMessage: 'I want to consolidate loans',
    description: 'Label-text för val av att lösa lån i formulär.',
  },
  otherIncomeLabel: {
    id: 'rahalaitos.fi.otherIncomeLabel',
    defaultMessage: 'Do you have any other income?',
    description: 'Label-text for asking the customer if they have any other income',
  },
  otherIncomeTooltip: {
    id: 'rahalaitos.fi.otherIncomeTooltip',
    defaultMessage: 'Do you have additional sources of income that are not stated already? This may include for example income from letting an apartment, income from a hobby, or state allowance. You need to prove your additional income through tax or payment slips',
    description: 'Tooltip-text for asking the customer if they have any other income',
  },
  dependantsLabel: {
    id: 'rahalaitos.fi.dependantsLabel',
    defaultMessage: 'Number of children under 21',
    description: 'Label-text för antal barn i formulär.',
  },
  dependantsPlaceholder: {
    id: 'rahalaitos.fi.dependantsPlaceholder',
    defaultMessage: 'Choose',
    description: 'Placeholder for dependants',
  },
  dependantsZero: {
    id: 'rahalaitos.fi.dependantsZero',
    defaultMessage: '0',
    description: 'No child',
  },
  dependantsOne: {
    id: 'rahalaitos.fi.dependantsOne',
    defaultMessage: '1',
    description: 'One child',
  },
  dependantsTwo: {
    id: 'rahalaitos.fi.dependantsTwo',
    defaultMessage: '2',
    description: 'Two children',
  },
  dependantsThree: {
    id: 'rahalaitos.fi.dependantsThree',
    defaultMessage: '3',
    description: 'Three children',
  },
  dependantsFour: {
    id: 'rahalaitos.fi.dependantsFour',
    defaultMessage: '4',
    description: 'Four children',
  },
  dependantsFive: {
    id: 'rahalaitos.fi.dependantsFive',
    defaultMessage: '5+',
    description: 'Five children',
  },
  coApplicantDependantsLabel: {
    id: 'rahalaitos.fi.coApplicantDependantsLabel',
    defaultMessage: 'Number of children under 21',
    description: 'Label text for number of children',
  },
  coApplicantDependantsPlaceholder: {
    id: 'rahalaitos.fi.coApplicantDependantsPlaceholder',
    defaultMessage: 'Choose',
    description: 'Placeholder for number of children',
  },
  emailPlaceholder: {
    id: 'rahalaitos.fi.emailPlaceholder',
    defaultMessage: 'name@email.com',
    description: 'Default-text för e-post i formulär.',
  },
  emailLabel: {
    id: 'rahalaitos.fi.emailLabel',
    defaultMessage: 'Email',
    description: 'Label-text för e-post i formulär.',
  },
  emailSuggestion: {
    id: 'rahalaitos.fi.emailSuggestion',
    defaultMessage: 'Did you mean',
    description: 'The pre-suggestion help text at the email input field.',
  },
  emailMustBeUnique: {
    id: 'rahalaitos.fi.emailMustBeUnique',
    defaultMessage: 'The main applicant and the co-applicant cannot have the same email.',
    description: 'Informing the customer that the applicant and co-applicant can not use the same email',
  },
  coApplicantEmailLabel: {
    id: 'rahalaitos.fi.coApplicantEmailLabel',
    defaultMessage: 'Co-applicant’s email',
    description: 'Label-text för e-post i formulär.',
  },
  coApplicantEmailPlaceholder: {
    id: 'rahalaitos.fi.coApplicantEmailPlaceholder',
    defaultMessage: 'name@email.com',
    description: 'Default-text for coApplicant email in form.',
  },
  emailRequired: {
    id: 'rahalaitos.fi.emailRequired',
    defaultMessage: 'Please enter your email',
    description: 'Error message informing the applicant that an email address must be provided',
  },
  emailNoSpaces: {
    id: 'rahalaitos.fi.emailNoSpaces',
    defaultMessage: 'The email cannot contain blank spaces',
    description: 'Error message informing the applicant that the provided email address must not contain any spaces',
  },
  emailNoAt: {
    id: 'rahalaitos.fi.emailNoAt',
    defaultMessage: 'A valid email needs to include @',
    description: 'Error message informing the applicant that the provided email address must contain the symbol "@"',
  },
  emailTooManyAts: {
    id: 'rahalaitos.fi.emailTooManyAts',
    defaultMessage: 'The email cannot contain more than one @.',
    description: 'Error message informing the applicant that the provided email address may not contain more than one "@"',
  },
  emailNoName: {
    id: 'rahalaitos.fi.emailNoName',
    defaultMessage: 'A valid email needs something before the @',
    description: 'Error message informing the applicant that the email address must contain a name in from of the email address',
  },
  emailDotBeforeAtSign: {
    id: 'rahalaitos.fi.emailDotBeforeAtSign',
    defaultMessage: 'The email domain cannot contain a dot (.) before @.',
    description: 'Error message informing the applicant that the domain of the email address can not contain two dots after each other',
  },
  emailTwoDots: {
    id: 'rahalaitos.fi.emailTwoDots',
    defaultMessage: 'The email cannot contain two dots in a row.',
    description: 'Error message informing the applicant that the domain of the email address can not contain two dots after each other',
  },
  emailNoDomain: {
    id: 'rahalaitos.fi.emailNoDomain',
    defaultMessage: 'A valid email needs to end with .fi/.com/.net or alike',
    description: 'Error message informing the applicant that the email address provided must end with a domain, for example ".com", ".fi" or ".nu"',
  },
  emailNoTopLevelDomain: {
    id: 'rahalaitos.fi.emailNoTopLevelDomain',
    defaultMessage: 'A valid email needs a web address after @',
    description: 'Error message informing the applicant that the email address provided must contain a domain name after the "@"',
  },
  coApplicantEmailRequired: {
    id: 'rahalaitos.fi.coApplicantEmailRequired',
    defaultMessage: "Please enter your co-applicant's email",
    description: 'Error message informing the applicant that an email address must be provided',
  },
  employerNamePlaceholder: {
    id: 'rahalaitos.fi.employerNamePlaceholder',
    defaultMessage: 'Employer name',
    description: 'Default-text för arbetsgivarnamn i formulär.',
  },
  employerNameLabel: {
    id: 'rahalaitos.fi.employerNameLabel',
    defaultMessage: 'Employer',
    description: 'Label-text för företagsnamn i formulär.',
  },
  employerNameRequired: {
    id: 'rahalaitos.fi.employerNameRequired',
    defaultMessage: 'Please enter the name of your employer',
    description: 'Error message informing the applicant that an employer must be provided',
  },
  coApplicantEmployerNamePlaceholder: {
    id: 'rahalaitos.fi.coApplicantEmployerNamePlaceholder',
    defaultMessage: 'Employer name',
    description: 'Default text employer name',
  },
  coApplicantEmployerNameLabel: {
    id: 'rahalaitos.fi.coApplicantEmployerNameLabel',
    defaultMessage: 'Employer of co-applicant',
    description: 'Label text for employer name',
  },
  coApplicantEmployerNameRequired: {
    id: 'rahalaitos.fi.coApplicantEmployerNameRequired',
    defaultMessage: "Please enter the name of your co-applicant's employer",
    description: 'Error message informing the applicant that an employer must be provided',
  },
  employerPhonePlaceholder: {
    id: 'rahalaitos.fi.employerPhonePlaceholder',
    defaultMessage: 'Employer phone number',
    description: 'Default-text för arbetsgivarens telefonnummer i formulär.',
  },
  employerPhoneLabel: {
    id: 'rahalaitos.fi.employerPhoneLabel',
    defaultMessage: 'Employer phone number',
    description: 'Label-text för arbetsgivarens telefonnummer i formulär.',
  },
  employerPhoneTooltip: {
    id: 'rahalaitos.fi.employerPhoneTooltip',
    defaultMessage: 'Your employer telephone number can make it easier for our partners if they need additional information when considering giving out a loan proposal',
    description: 'Tooltip-text för arbetsgivarens telefonnummer i formulär.',
  },
  employerPhoneRequired: {
    id: 'rahalaitos.fi.employerPhoneRequired',
    defaultMessage: "Please enter your employer's phone number",
    description: 'Error message for when the customer hasnt filled in a phone number to their employer',
  },
  coApplicantEmployerPhoneRequired: {
    id: 'rahalaitos.fi.coApplicantEmployerPhoneRequired',
    defaultMessage: "Please enter their employer's phone number",
    description: 'Error message for when the customer hasnt filled in a phone number to their coapplicants employer',
  },
  employerPhoneWrongNumber: {
    id: 'rahalaitos.fi.employerPhoneWrongNumber',
    defaultMessage: 'The phone number appears to be incorrect. Please enter a valid number',
    description: 'Error message for when the customer fills in a non-valid input for the number to their employer.',
  },
  employerPhoneWrongBeginning: {
    id: 'rahalaitos.fi.employerPhoneWrongBeginning',
    defaultMessage: 'The number needs to start with 0, +358 or 00358.',
    description: 'Error message for when the customer fills in a foreign phone number to their employer.',
  },
  employerPhoneTooShort: {
    id: 'rahalaitos.fi.employerPhoneTooShort',
    defaultMessage: "The phone number is too short. Verify that you haven't forgotten a digit",
    description: 'Error message for when the customer fills in a too short phone number to their employer.',
  },
  employerPhoneTooLong: {
    id: 'rahalaitos.fi.employerPhoneTooLong',
    defaultMessage: "The phone number is too long. Verify that you haven't added too many digits.",
    description: 'Error message for when the customer fills in a too long phone number to their employer.',
  },
  coApplicantEmployerPhonePlaceholder: {
    id: 'rahalaitos.fi.coApplicantEmployerPhonePlaceholder',
    defaultMessage: 'Employer phone number',
    description: 'placeholder text for coApplicant employer phone number in form.',
  },
  coApplicantEmployerPhoneLabel: {
    id: 'rahalaitos.fi.coApplicantEmployerPhoneLabel',
    defaultMessage: 'Co-applicant’s employer phone number',
    description: 'label text for coApplicant employer phone number in form.',
  },
  employmentTypeLabel: {
    id: 'rahalaitos.fi.employmentTypeLabel',
    defaultMessage: 'Employment',
    description: 'Label-text för sysselsättning i formulär.',
  },
  employmentTypePlaceholder: {
    id: 'rahalaitos.fi.employmentTypePlaceholder',
    defaultMessage: 'Choose',
    description: 'Placeholder for employment type',
  },
  employmentTypePermanent: {
    id: 'rahalaitos.fi.employmentTypePermanent',
    defaultMessage: 'Permanent',
    description: 'Employment type - Tenured/employed indefinitely/until further notice',
  },
  employmentTypeTemporary: {
    id: 'rahalaitos.fi.employmentTypeTemporary',
    defaultMessage: 'Temporary',
    description: 'Employment type - Temporary',
  },
  employmentTypePartTime: {
    id: 'rahalaitos.fi.employmentTypePartTime',
    defaultMessage: 'Part time',
    description: 'Employment type - Part time',
  },
  employmentTypeRetired: {
    id: 'rahalaitos.fi.employmentTypeRetired',
    defaultMessage: 'Pensioner',
    description: 'Employment type - Retired/Early retirement',
  },
  employmentTypeParentalLeave: {
    id: 'rahalaitos.fi.employmentTypeParentalLeave',
    defaultMessage: 'Parental leave',
    description: 'Employment type - Parental leave',
  },
  employmentTypeStudent: {
    id: 'rahalaitos.fi.employmentTypeStudent',
    defaultMessage: 'Student',
    description: 'Employment type - Student',
  },
  employmentTypeUnemployed: {
    id: 'rahalaitos.fi.employmentTypeUnemployed',
    defaultMessage: 'Unemployed',
    description: 'Employment type - Unemployed',
  },
  employmentTypeDisabilityPension: {
    id: 'rahalaitos.fi.employmentTypeDisabilityPension',
    defaultMessage: 'Disability pension',
    description: 'Employment type - Retired/pensioner on disability',
  },
  employmentTypeRehabilitation: {
    id: 'rahalaitos.fi.employmentTypeRehabilitation',
    defaultMessage: 'Rehabilitation',
    description: 'Employment type - rehabilitation',
  },
  employmentTypeSelfEmployed: {
    id: 'rahalaitos.fi.employmentTypeSelfEmployed',
    defaultMessage: 'Self employed',
    description: 'Employment type - Self employed',
  },
  employmentTypeOther: {
    id: 'rahalaitos.fi.employmentTypeOther',
    defaultMessage: 'Other',
    description: 'Employment type - other',
  },
  employmentTypeByTheHour: {
    id: 'rahalaitos.fi.employmentTypeByTheHour',
    defaultMessage: 'Hourly wage',
    description: 'Employment type - Extra work/hourly contract',
  },
  employmentTypeEmployedAtOwnCompany: {
    id: 'rahalaitos.fi.employmentTypeEmployedAtOwnCompany',
    defaultMessage: 'Own business',
    description: 'Employment type - Has his/her own business',
  },
  coApplicantEmploymentTypeLabel: {
    id: 'rahalaitos.fi.coApplicantEmploymentTypeLabel',
    defaultMessage: 'Employment of co-applicant',
    description: 'Label-text för sysselsättnig i formulär.',
  },
  coApplicantEmploymentTypePlaceholder: {
    id: 'rahalaitos.fi.coApplicantEmploymentTypePlaceholder',
    defaultMessage: 'Choose',
    description: 'Placeholder for co-applicant employment type',
  },
  employmentSinceMonthPlaceholder: {
    id: 'rahalaitos.fi.employmentSinceMonthPlaceholder',
    defaultMessage: 'Month',
    description: 'Default text for "employment since"-input in months, placed inside form',
  },
  employmentSinceYearPlaceholder: {
    id: 'rahalaitos.fi.employmentSinceYearPlaceholder',
    defaultMessage: 'Year',
    description: 'Default text for "employment since"-input in years, placed inside form',
  },
  employmentSinceYearLabel: {
    id: 'rahalaitos.fi.employmentSinceYearLabel',
    defaultMessage: 'Employed since (year)',
    description: 'Label for "employment since"-input in years, placed inside form',
  },
  employmentSinceMonthLabel: {
    id: 'rahalaitos.fi.employmentSinceMonthLabel',
    defaultMessage: 'Employed since (month)',
    description: 'Label for "employment since"-input in months, placed inside form',
  },
  employedSinceMonthPlaceholder: {
    id: 'rahalaitos.fi.employedSinceMonthPlaceholder',
    defaultMessage: 'Month',
    description: 'Default text for "employment since"-input in months, placed inside form',
  },
  retiredEmploymentSinceLabel: {
    id: 'rahalaitos.fi.retiredEmploymentSinceLabel',
    defaultMessage: 'Retired since',
    description: '',
  },
  employedSinceRequiredYear: {
    id: 'rahalaitos.fi.employedSinceRequiredYear',
    defaultMessage: 'Please enter the year you started your current employment',
    description: 'Error message informing the applicant that they must pass in which year their employment started',
  },
  coAppEmployedSinceRequiredYear: {
    id: 'rahalaitos.fi.coApplicant.employedSinceRequiredYear',
    defaultMessage: 'Please enter the year your co-applicant started their current employment',
    description: 'Error message informing the coapplicant that they must pass in which year their employment started',
  },
  employedSinceRequiredMonth: {
    id: 'rahalaitos.fi.employedSinceRequiredMonth',
    defaultMessage: 'Please enter the month you started your current employment',
    description: 'Error message informing the applicant that they must pass in which month their employment started',
  },
  coAppEmployedSinceRequiredMonth: {
    id: 'rahalaitos.fi.coApplicant.employedSinceRequiredMonth',
    defaultMessage: 'Please enter the month your co-applicant started their current employment',
    description: 'Error message informing the coapplicant that they must pass in which month their employment started',
  },
  employedSinceOnlyNumbers: {
    id: 'rahalaitos.fi.employedSinceOnlyNumbers',
    defaultMessage: 'Please enter the year in digits (e.g. 2010).',
    description: 'Error message informing the applicant that they may only use digits when filling in which year their employment started',
  },
  employedSinceFourDigits: {
    id: 'rahalaitos.fi.employedSinceFourDigits',
    defaultMessage: 'Please write the year in 4 digits, e.g. 2010.',
    description: 'Error message informing the applicant that the format for "year their employment started" should be filled in with four digits',
  },
  employedSinceTooFarBack: {
    id: 'rahalaitos.fi.employedSinceTooFarBack',
    defaultMessage: 'Enter the year you started (e.g. 2010).',
    description: 'Error message informing the applicant that the year their employment started is set to far back in time',
  },
  coApplicantEmployedSinceTooFarBack: {
    id: 'rahalaitos.fi.coApplicant.employedSinceTooFarBack',
    defaultMessage: 'Enter the year they started (e.g. 2010).',
    description: 'Error message informing the coapplicant started their employment to far back in time',
  },
  employedSinceStartTimeInTheFuture: {
    id: 'rahalaitos.fi.employedSinceStartTimeInTheFuture',
    defaultMessage: 'Your employment date cannot be in the future',
    description: 'Error message informing the applicant that their "start time of the employment" cannot be set to a date in the future',
  },
  coAppEmployedSinceStartTimeInTheFuture: {
    id: 'rahalaitos.fi.employedSinceCoApplicant.startTimeInTheFuture',
    defaultMessage: 'Their employment date cannot be in the future.',
    description: 'Error message informing the coapplicant that their "start time of the employment" cannot be set to a date in the future',
  },
  employedSinceStartTimeInTheFutureMonth: {
    id: 'rahalaitos.fi.employedSinceStartTimeInTheFutureMonth',
    defaultMessage: 'The employment date cannot be in the future',
    description: 'Error message informing the start date is in the future',
  },
  homeCostPlaceholder: {
    id: 'rahalaitos.fi.homeCostPlaceholder',
    defaultMessage: 'E.g. € 500',
    description: 'Default-text för boendekostnad i formulär.',
  },
  homeCostLabel: {
    id: 'rahalaitos.fi.homeCostLabel',
    defaultMessage: 'Housing cost (€/mth)',
    description: 'Label-text för boendekostnad i formulär.',
  },
  homeCostRequired: {
    id: 'rahalaitos.fi.homeCostRequired',
    defaultMessage: 'Please enter your share of monthly housing cost',
    description: 'Inform the customer that they must pass in a monthly cost for their current home-situation (ex: rent)',
  },
  homeCostOnlyDigits: {
    id: 'rahalaitos.fi.homeCostOnlyDigits',
    defaultMessage: 'Please write your housing cost in numbers only',
    description: 'Inform the customer that they may only pass in digits in the input for the monthly cost of their home-situation',
  },
  homeCostTooHigh: {
    id: 'rahalaitos.fi.homeCostTooHigh',
    defaultMessage: 'Your housing cost cannot be more than {maxCost, number} €/mth for you to apply',
    description: 'Inform the customer that we may unfortunately only accept a monthly cost of "x" and that their cost is to high',
  },
  homeCostTooLow: {
    id: 'rahalaitos.fi.homeCostTooLow',
    defaultMessage: 'Enter monthly cost for your accommodation.',
    description: 'Inform the customer that their passed in monthly cost for their home-situation is set to low, for example "0"',
  },
  coApplicantHomeCostPlaceholder: {
    id: 'rahalaitos.fi.coApplicantHomeCostPlaceholder',
    defaultMessage: 'E.g. € 500',
    description: 'Default-text för boendekostnad i formulär.',
  },
  coApplicantHomeCostLabel: {
    id: 'rahalaitos.fi.coApplicantHomeCostLabel',
    defaultMessage: "Co-applicant's housing cost (€/mth)",
    description: 'Label-text för boendekostnad i formulär.',
  },
  coApplicantHomeCostRequired: {
    id: 'rahalaitos.fi.coApplicantHomeCostRequired',
    defaultMessage: "Please enter your co-applicant's monthly housing cost",
    description: 'Inform the customer that they must pass in a monthly cost for their current home-situation (ex: rent)',
  },
  coApplicantHomeCostOnlyDigits: {
    id: 'rahalaitos.fi.coApplicantHomeCostOnlyDigits',
    defaultMessage: 'Please write the housing cost in numbers only',
    description: 'Inform the customer that they may only pass in digits in the input for the monthly cost of their home-situation',
  },
  coApplicantHomeCostTooHigh: {
    id: 'rahalaitos.fi.coApplicantHomeCostTooHigh',
    defaultMessage: 'Their housing cost cannot be more than {maxCost, number} €/mth for you to apply',
    description: 'Inform the customer that we may unfortunately only accept a monthly cost of "x" and that their cost is to high',
  },
  coApplicantHomeCostTooLow: {
    id: 'rahalaitos.fi.coApplicantHomeCostTooLow',
    defaultMessage: 'Enter the monthly cost for their accommodation.',
    description: 'Inform the customer that their passed in monthly cost for their home-situation is set to low, for example "0"',
  },
  homeTypeLabel: {
    id: 'rahalaitos.fi.homeTypeLabel',
    defaultMessage: 'Housing',
    description: 'Label-text för boendeform i formulär.',
  },
  homeTypePlaceholder: {
    id: 'rahalaitos.fi.homeTypePlaceholder',
    defaultMessage: 'Choose',
    description: 'Placeholder for home type',
  },
  homeTypeOther: {
    id: 'rahalaitos.fi.homeTypeOther',
    defaultMessage: 'Other',
    description: 'Residential type - other',
  },
  homeTypeRentedApartment: {
    id: 'rahalaitos.fi.homeTypeRentedApartment',
    defaultMessage: 'Rented apartment',
    description: 'Residential type - Rented apartment',
  },
  homeTypeVilla: {
    id: 'rahalaitos.fi.homeTypeVilla',
    defaultMessage: 'Villa',
    description: 'Residential type - Villa',
  },
  homeTypeCondominium: {
    id: 'rahalaitos.fi.homeTypeCondominium',
    defaultMessage: 'Condominium',
    description: 'Residential type - Condominium',
  },
  homeTypeParents: {
    id: 'rahalaitos.fi.homeTypeParents',
    defaultMessage: 'Parents',
    description: 'Residential type - Parents',
  },
  homeTypeCategorieOther: {
    id: 'rahalaitos.fi.homeTypeCategorieOther',
    defaultMessage: 'Other',
    description: 'Residential category type - Other',
  },
  homeTypeCategorieTerraced: {
    id: 'rahalaitos.fi.homeTypeCategorieTerraced',
    defaultMessage: 'Terraced house',
    description: 'Residential category type - Terraced house',
  },
  homeTypeCategorieDetached: {
    id: 'rahalaitos.fi.homeTypeCategorieDetached',
    defaultMessage: 'Detached house',
    description: 'Residential category type - Detached house',
  },
  homeTypeCategorieTownHouse: {
    id: 'rahalaitos.fi.homeTypeCategorieTownHouse',
    defaultMessage: 'Town house',
    description: 'Residential category type - Town house',
  },
  homeTypeCategorieBlock: {
    id: 'rahalaitos.fi.homeTypeCategorieBlock',
    defaultMessage: 'Block of flats',
    description: 'Residential category type - Block',
  },
  homeTypeCategoryDescriptionLabel: {
    id: 'rahalaitos.fi.homeTypeCategoryDescriptionLabel',
    defaultMessage: 'Type of apartment',
    description: 'Label for the type of apartment field',
  },
  homeTypeCategoryDescriptionPlaceholder: {
    id: 'rahalaitos.fi.homeTypeCategoryDescriptionPlaceholder',
    defaultMessage: 'Choose',
    description: 'Placeholder for the type of apartment field',
  },
  coApplicantHomeTypeLabel: {
    id: 'rahalaitos.fi.coApplicantHomeTypeLabel',
    defaultMessage: 'Housing of co-applicant',
    description: 'Label-text för boendeform i formulär.',
  },
  coApplicantHomeTypePlaceholder: {
    id: 'rahalaitos.fi.coApplicantHomeTypePlaceholder',
    defaultMessage: 'Choose',
    description: 'Placeholder for co-applicant home type',
  },
  coApplicantHomeTypeCategoryDescriptionLabel: {
    id: 'rahalaitos.fi.coApplicantHomeTypeCategoryDescriptionLabel',
    defaultMessage: 'Type of apartment',
    description: 'Label for the type of apartment field',
  },
  loanPurposeRequired: {
    id: 'rahalaitos.fi.loanPurposeRequired',
    defaultMessage: 'The loan purpose is required.',
    description: '',
  },
  loanPurposeConsolidateLoans: {
    id: 'rahalaitos.fi.loanPurposeConsolidateLoans',
    defaultMessage: 'Consolidate loans',
    description: 'Purpose of the loan - Consolidate loans',
  },
  loanPurposeVehicles: {
    id: 'rahalaitos.fi.loanPurposeVehicles',
    defaultMessage: 'Vehicle',
    description: 'Purpose of the loan - Vehicle expenses',
  },
  loanPurposeEverydayExpenses: {
    id: 'rahalaitos.fi.loanPurposeEverydayExpenses',
    defaultMessage: 'Consumption',
    description: 'Purpose of the loan - Shopping/consumption',
  },
  loanPurposeRenovation: {
    id: 'rahalaitos.fi.loanPurposeRenovation',
    defaultMessage: 'Renovation',
    description: 'Purpose of the loan - Renovation',
  },
  loanPurposeTravel: {
    id: 'rahalaitos.fi.loanPurposeTravel',
    defaultMessage: 'Travel',
    description: 'Purpose of the loan - travel',
  },
  loanPurposeBusiness: {
    id: 'rahalaitos.fi.loanPurposeBusiness',
    defaultMessage: 'Business',
    description: 'Purpose of the loan - Business',
  },
  loanPurposeHealth: {
    id: 'rahalaitos.fi.loanPurposeHealth',
    defaultMessage: 'Health',
    description: 'Purpose of the loan - Health',
  },
  loanPurposeServices: {
    id: 'rahalaitos.fi.loanPurposeServices',
    defaultMessage: 'Services',
    description: 'Purpose of the loan - Services',
  },
  loanPurposeInvestment: {
    id: 'rahalaitos.fi.loanPurposeInvestment',
    defaultMessage: 'Investment',
    description: 'Purpose of the loan - Investment',
  },
  loanPurposeStudies: {
    id: 'rahalaitos.fi.loanPurposeStudies',
    defaultMessage: 'Studies',
    description: 'Purpose of the loan - Studies',
  },
  loanPurposeOther: {
    id: 'rahalaitos.fi.loanPurposeOther',
    defaultMessage: 'Other',
    description: 'Purpose of the loan - other',
  },
  mergeLoanYes: {
    id: 'rahalaitos.fi.mergeLoanYes',
    defaultMessage: 'Yes',
    description: '',
  },
  mergeLoanNo: {
    id: 'rahalaitos.fi.mergeLoanNo',
    defaultMessage: 'No',
    description: '',
  },
  monthlySalaryPlaceholder: {
    id: 'rahalaitos.fi.monthlySalaryPlaceholder',
    defaultMessage: 'E.g. € 2 500',
    description: 'Default-text för inkomst i formulär.',
  },
  monthlySalaryLabel: {
    id: 'rahalaitos.fi.monthlySalaryLabel',
    defaultMessage: 'Monthly income before taxes (€/mth)',
    description: 'Label-text för inkomst i formulär.',
  },
  coApplicantMonthlySalaryPlaceholder: {
    id: 'rahalaitos.fi.coApplicantMonthlySalaryPlaceholder',
    defaultMessage: 'E.g. 2 500',
    description: 'Default-text för inkomst i formulär.',
  },
  coApplicantMonthlySalaryLabel: {
    id: 'rahalaitos.fi.coApplicantMonthlySalaryLabel',
    defaultMessage: 'Co-applicant’s monthly income before taxes (€/mth)',
    description: 'Label-text för inkomst i formulär.',
  },
  monthlySalaryBeforeTaxRequired: {
    id: 'rahalaitos.fi.monthlySalaryBeforeTaxRequired',
    defaultMessage: 'Please provide your monthly income before taxes (€/mth)',
    description: 'Error message informing the applicant that a monthly salary before taxes must be provided',
  },
  monthlySalaryAfterTaxRequired: {
    id: 'rahalaitos.fi.monthlySalaryAfterTaxRequired',
    defaultMessage: 'Please provide your monthly income after taxes (€/mth)',
    description: 'Error message informing the applicant that a monthly salary after taxes must be provided',
  },
  monthlySalaryOnlynumbers: {
    id: 'rahalaitos.fi.monthlySalaryOnlynumbers',
    defaultMessage: 'Please write your income in numbers only',
    description: 'Error message informing the customer that only numbers are allowed to be passed in',
  },
  monthlySalaryTooLow: {
    id: 'rahalaitos.fi.monthlySalaryTooLow',
    defaultMessage: 'Your income must be at least € {minSalary, number} /mth in order to apply',
    description: 'Error message informing the customer that the monthly salary provided is to low and information that you need to have a monthly salary of at least x in order to compare loans',
  },
  monthlySalaryTooHigh: {
    id: 'rahalaitos.fi.monthlySalaryTooHigh',
    defaultMessage: 'Your income must not be more than € {maxSalary, number} /mth for you to apply',
    description: 'Error message informing the customer that the monthly salary provided is to high',
  },
  monthlySalaryAfterTaxInvalid: {
    id: 'rahalaitos.fi.monthlySalaryAfterTaxInvalid',
    defaultMessage: 'Income after tax can not be higher than income before tax',
    description: 'Error message informing the customer that the monthly salary before tax is to high',
  },
  coApplicantMonthlySalaryRequired: {
    id: 'rahalaitos.fi.coApplicantMonthlySalaryRequired',
    defaultMessage: "Please enter your co-applicant's monthly income before tax (€/mth)",
    description: 'Error message informing the applicant that a monthly salary must be provided',
  },
  coApplicantMonthlySalaryOnlynumbers: {
    id: 'rahalaitos.fi.coApplicantMonthlySalaryOnlynumbers',
    defaultMessage: "Please enter your co-applicant's income in numbers only",
    description: 'Error message informing the customer that only numbers are allowed to be passed in',
  },
  coApplicantMonthlySalaryTooLow: {
    id: 'rahalaitos.fi.coApplicantMonthlySalaryTooLow',
    defaultMessage: 'Their income must be at least € {minSalary, number} /mth in order to apply',
    description: 'Error message informing the customer that the monthly salary provided is to low and information that you need to have a monthly salary of at least x in order to compare loans',
  },
  coApplicantMonthlySalaryTooHigh: {
    id: 'rahalaitos.fi.coApplicantMonthlySalaryTooHigh',
    defaultMessage: 'Their income must not be more than € {maxSalary, number} /mth for you to apply',
    description: 'Error message informing the customer that the monthly salary provided is to high',
  },
  coApplicantSpouseMonthlyIncomeLabel: {
    id: 'rahalaitos.fi.coApplicantSpouseMonthlyIncomeLabel',
    defaultMessage: "Co-applicant's spouse monthly income before taxes (€/mth)",
    description: 'Label for spouse monthly income field',
  },
  coApplicantSpouseMonthlyIncomePlaceholder: {
    id: 'rahalaitos.fi.coApplicantSpouseMonthlyIncomePlaceholder',
    defaultMessage: "Co-applicant's spouse monthly income before taxes (€/mth)",
    description: 'Placeholder for spouse monthly income field',
  },
  coApplicantSpouseMonthlySalaryBeforeTaxRequired: {
    id: 'rahalaitos.fi.coApplicantSpouseMonthlySalaryBeforeTaxRequired',
    defaultMessage: "Co-applicant's spouse monthly income before tax is required",
    description: 'Error message for not filling in spouse monthly income',
  },
  coApplicantSpouseMonthlySalaryOnlynumbers: {
    id: 'rahalaitos.fi.coApplicantSpouseMonthlySalaryOnlynumbers',
    defaultMessage: "Please write your co-applicant's spouse income in numbers only",
    description: 'Error message for only allowed to use numbers',
  },
  coApplicantSpouseMonthlySalaryMustBePositive: {
    id: 'rahalaitos.fi.coApplicantSpouseMonthlySalaryMustBePositive',
    defaultMessage: "Co-applicant's spouse monthly income can not be negative",
    description: 'Error message for only allowed to use numbers',
  },
  otherIncomeBeforeTaxRequired: {
    id: 'rahalaitos.fi.otherMonthlyIncomeBeforeTaxRequired',
    defaultMessage: 'Please provide your other monthly income before taxes (€/mth)',
    description: 'Error message informing the applicant that additional monthly income before taxes must be provided',
  },
  otherIncomeAfterTaxRequired: {
    id: 'rahalaitos.fi.otherMonthlyIncomeAfterTaxRequired',
    defaultMessage: 'Please provide your other monthly income after taxes (€/mth)',
    description: 'Error message informing the applicant that additional monthly income after taxes must be provided',
  },
  otherIncomeOnlyNumbers: {
    id: 'rahalaitos.fi.otherMonthlySalaryOnlynumbers',
    defaultMessage: 'Please write your other monthly income in numbers only',
    description: 'Error message informing the customer that only numbers are allowed to be passed in',
  },
  coApplicantOtherIncomeBeforeTaxRequired: {
    id: 'rahalaitos.fi.coApplicantOtherMonthlyIncomeBeforeTaxRequired',
    defaultMessage: "Please provide your co-applicant's other monthly income before taxes (€/mth)",
    description: "Error message informing the co-applicant's additional monthly income before taxes must be provided",
  },
  coApplicantOtherIncomeAfterTaxRequired: {
    id: 'rahalaitos.fi.coApplicantOtherMonthlyIncomeAfterTaxRequired',
    defaultMessage: "Please provide your co-applicant's other monthly income after taxes (€/mth)",
    description: "Error message informing the co-applicant's additional monthly income after taxes must be provided",
  },
  coApplicantOtherIncomeOnlyNumbers: {
    id: 'rahalaitos.fi.coApplicantOtherMonthlySalaryOnlynumbers',
    defaultMessage: "Please write your co-applicant's other monthly income in numbers only",
    description: 'Error message informing the customer that only numbers are allowed to be passed in for their co-applicant',
  },
  nationalIdPlaceholder: {
    id: 'rahalaitos.fi.nationalIdPlaceholder',
    defaultMessage: 'DDMMYY-XXXX',
    description: 'Default-text för personnummer i formulär.',
  },
  nationalIdLabel: {
    id: 'rahalaitos.fi.nationalIdLabel',
    defaultMessage: 'National ID',
    description: 'Label-text för personnummer i formulär.',
  },
  nationalIdMustBeUnique: {
    id: 'rahalaitos.fi.nationalIdMustBeUnique',
    defaultMessage: 'The main applicant and the co-applicant cannot be the same person.',
    description: 'Informing the customer that the applicant and co-applicant can not be the same person/use the same social security number',
  },
  nationalIdRequired: {
    id: 'rahalaitos.fi.nationalIdRequired',
    defaultMessage: 'Please enter your Finnish ID number',
    description: 'Error message for when a social security number must be provided',
  },
  nationalIdWrongFormat: {
    id: 'rahalaitos.fi.nationalIdWrongFormat',
    defaultMessage: 'Please write in the correct format, 10 or 12 digits, e.g. 221180-012A',
    description: 'Error message when the social security number is in the wrong format. Provides an example of a correct format social security number',
  },
  nationalIdWrongDate: {
    id: 'rahalaitos.fi.nationalIdWrongDate',
    defaultMessage: 'Your birth date {dateOfBirthString} is not valid. Please make sure there are no mistakes',
    description: 'Error message when providing birth date incorrectly',
  },
  nationalIdDateInTheFuture: {
    id: 'rahalaitos.fi.nationalIdDateInTheFuture',
    defaultMessage: '{dateOfBirthString} is a future date, and cannot be used',
    description: 'Error message when choosing date of birth as a date in the future',
  },
  nationalIdTooYoung: {
    id: 'rahalaitos.fi.nationalIdTooYoung',
    defaultMessage: 'You have to be at least {minAge} years of age to submit an application.',
    description: 'Error message when providing a date of birth making you younger than the minimum age allowed',
  },
  nationalIdTooOld: {
    id: 'rahalaitos.fi.nationalIdTooOld',
    defaultMessage: 'Unfortunately, we can only help people up to {maxAge} years of age.',
    description: 'Error message when providing a date of birth making you older than the maximum age allowed',
  },
  nationalIdInvalid: {
    id: 'rahalaitos.fi.nationalIdInvalid',
    defaultMessage: 'Your 4 last digits do not seem to match your birth date. Please verify them',
    description: 'Error message when providing a social security number wrongly formatted. Asks the customer to review their last four digits in their social security number',
  },
  coApplicantNationalIdPlaceholder: {
    id: 'rahalaitos.fi.coApplicantNationalIdPlaceholder',
    defaultMessage: 'DDMMYY-XXXX',
    description: 'Default-text för personnummer i formulär.',
  },
  coApplicantNationalIdLabel: {
    id: 'rahalaitos.fi.coApplicantNationalIdLabel',
    defaultMessage: 'National ID of co-applicant',
    description: 'Label-text för personnummer i formulär.',
  },
  coApplicantNationalIdrequired: {
    id: 'rahalaitos.fi.coApplicantNationalIdrequired',
    defaultMessage: "Please enter your co-applicant's Finnish ID number",
    description: 'Error message for when a social security number must be provided',
  },
  coApplicantNationalIdWrongFormat: {
    id: 'rahalaitos.fi.coApplicantNationalIdWrongFormat',
    defaultMessage: 'Please write in the correct format, 10 or 12 digits, e.g. 221180-012A',
    description: 'Error message when the social security number is in the wrong format. Provides an example of a correctly formatted social security number',
  },
  coApplicantNationalIdWrongDate: {
    id: 'rahalaitos.fi.coApplicantNationalIdWrongDate',
    defaultMessage: 'Their birth date {dateOfBirthString} is not valid, please make sure your input is correct',
    description: 'Error message when providing birth date incorrectly',
  },
  coApplicantNationalIdDateInTheFuture: {
    id: 'rahalaitos.fi.coApplicantNationalIdDateInTheFuture',
    defaultMessage: '{dateOfBirthString} is a future date, and cannot be used',
    description: 'Error message when choosing date of birth as a date in the future',
  },
  coApplicantNationalIdInvalid: {
    id: 'rahalaitos.fi.coApplicantNationalIdInvalid',
    defaultMessage: 'Their 4 last digits do not seem to match the birth date. Please verify them',
    description: 'Error message when providing a social security number wrongly formatted. Asks the customer to review their last four digits in their social security number',
  },
  phoneNumberPlaceholder: {
    id: 'rahalaitos.fi.phoneNumberPlaceholder',
    defaultMessage: '04__ __ __ __',
    description: 'Default-text för mobilnummer i formulär.',
  },
  phoneNumberLabel: {
    id: 'rahalaitos.fi.phoneNumberLabel',
    defaultMessage: 'Phone number',
    description: '',
  },
  phoneNumberMustBeUnique: {
    id: 'rahalaitos.fi.phoneNumberMustBeUnique',
    defaultMessage: 'The main applicant and the co-applicant cannot have the same phone number.',
    description: 'Informing the customer/applicant that their co-applicant may not have an identical phone number as theirs',
  },
  phoneNumberRequired: {
    id: 'rahalaitos.fi.phoneNumberRequired',
    defaultMessage: 'Please enter your phone number',
    description: '',
  },
  phoneNumberWrongBeginning: {
    id: 'rahalaitos.fi.phoneNumberWrongBeginning',
    defaultMessage: 'We only accept cell phone numbers. The number needs to start with 0, +358 or 00358',
  },
  phoneNumberFormatError: {
    id: 'rahalaitos.fi.phoneNumberFormatError',
    defaultMessage: 'Must begin with 0 or Finnish country code (+358).',
    description: '',
  },
  phoneNumberPrefixError: {
    id: 'rahalaitos.fi.phoneNumberPrefixError',
    defaultMessage: 'Your phone number must begin with 0, +358 or 00358',
    description: '',
  },
  phoneNumberWrongNumber: {
    id: 'rahalaitos.fi.phoneNumberWrongNumber',
    defaultMessage: 'The phone number appears to be incorrect. Please enter a valid Finnish mobile phone number.',
  },
  phoneNumberGeneralError: {
    id: 'rahalaitos.fi.phoneNumberGeneralError',
    defaultMessage: 'The phone number appears to be incorrect. Please enter a valid Finnish mobile phone number.',
  },
  phoneNumberTooShort: {
    id: 'rahalaitos.fi.phoneNumberTooShort',
    defaultMessage: "The phone number is too short. Verify that you haven't forgotten any digits",
    description: 'Error message for when the customer fills in a too short phone number.',
  },
  phoneNumberTooLong: {
    id: 'rahalaitos.fi.phoneNumberTooLong',
    defaultMessage: "The phone number is too long. Make sure you haven't added too many digits",
    description: 'Error message for when the customer fills in a too long phone number.',
  },
  coApplicantPhoneNumberPlaceholder: {
    id: 'rahalaitos.fi.coApplicantPhoneNumberPlaceholder',
    defaultMessage: '04__ __ __ __',
    description: 'Default-text för coApplicant mobilnummer i formulär.',
  },
  coApplicantPhoneNumberLabel: {
    id: 'rahalaitos.fi.coApplicantPhoneNumberLabel',
    defaultMessage: 'Phone number of co-applicant',
    description: 'label for coApplicant mobile number in form.',
  },
  coApplicantPhoneNumberRequired: {
    id: 'rahalaitos.fi.coApplicantPhoneNumberRequired',
    defaultMessage: "Please enter your co-applicant's phone number",
  },
  coApplicantEmploymentSinceYearPlaceholder: {
    id: 'rahalaitos.fi.coApplicantEmploymentSinceYearPlaceholder',
    defaultMessage: 'e.g 2002',
    description: 'Default text for "employment since"-input in years, placed inside form',
  },
  coApplicantEmploymentSinceYearLabel: {
    id: 'rahalaitos.fi.coApplicantEmploymentSinceYearLabel',
    defaultMessage: 'Co-applicant employed since (year)',
    description: 'Label for "employment since"-input in years, placed inside form',
  },
  coApplicantEmploymentSinceMonthLabel: {
    id: 'rahalaitos.fi.coApplicantEmploymentSinceMonthLabel',
    defaultMessage: 'Co-applicant employed since (month)',
    description: 'Label for "employment since"-input in months, placed inside form',
  },
  coApplicantEmploymentSinceMonthPlaceholder: {
    id: 'rahalaitos.fi.coApplicantEmploymentSinceMonthPlaceholder',
    defaultMessage: 'Month',
    description: 'Default text for "employment since"-input in months, placed inside form',
  },
  betterTermsText: {
    id: 'rahalaitos.fi.betterTermsText',
    defaultMessage: 'Having a co-applicant often results in better interest rates.',
    description: '',
  },
  submitErrorGeneral: {
    id: 'rahalaitos.fi.submitErrorGeneral',
    defaultMessage: 'Your application could not be submitted. Customer service is more than happy to help you through the process. Call: 0942456000 or click the button below and we will call you as soon as we can on <i>{customerPhoneNumber}</i>',
    description: 'Default-text för back-end fel i formulär.',
  },
  submitErrorUncaught: {
    id: 'rahalaitos.fi.submitErrorUncaught',
    defaultMessage: 'We have technical issues at the moment and your application could not be submitted. Please contact customer service for more help 0942456000',
    description: 'Default-text for when a customer tries to submit their application but there was an error on the client side.',
  },
  validationErrorGeneral: {
    id: 'rahalaitos.fi.validationErrorGeneral',
    defaultMessage: 'Some of the fields are not filled in correctly. Please correct these and try to submit again.',
    description: 'Default-text för fel i fält.',
  },
  validationErrorField: {
    id: 'rahalaitos.fi.validationErrorField',
    defaultMessage: 'This field is not filled in correctly. Please correct it and try submitting again.',
    description: 'Default-text för fel i fält.',
  },
  fieldAlreadyInUseEmail: {
    id: 'rahalaitos.fi.fieldAlreadyInUseEmail',
    defaultMessage: 'This email address already belongs to an application.',
    description: 'Field error message informing the customer that the given email is already in use in another application',
  },
  fieldAlreadyInUseNationalId: {
    id: 'rahalaitos.fi.fieldAlreadyInUseNationalId',
    defaultMessage: 'You have an ongoing application, to access it — click "Log in" in the menu. To make changes to your application, please call customer service on: <span>{phoneNumber}</span>',
    description: 'Default-text för back-end fel i formulär.',
  },
  formSubmit: {
    id: 'rahalaitos.fi.formSubmit',
    defaultMessage: 'Apply now - for free',
    description: 'Label for submit button',
  },
  monthlyCostApproximateMonthlyCostLabel: {
    id: 'rahalaitos.fi.monthlyCostApproximateMonthlyCostLabel',
    defaultMessage: 'Monthly cost approx. *',
    description: 'The label for the apprax. monthly cost',
  },
  monthlyCostApproximateCostLabel: {
    id: 'rahalaitos.fi.monthlyCostApproximateCostLabel',
    defaultMessage: 'Approximate cost',
    description: 'approx cost',
  },
  monthlyCostApproximateCostPerMonthDesktop: {
    id: 'rahalaitos.fi.monthlyCostApproximateCostPerMonthDesktop',
    defaultMessage: '{monthlyCost} / month *',
    description: 'Shows the apprx. monthly cost on desktop',
  },
  approximateMonthlyCostMobile: {
    id: 'rahalaitos.fi.approximateMonthlyCostMobile',
    defaultMessage: 'Approximate Cost {monthlyCost} EUR/month',
    description: 'Shows the apprx. monthly cost on mobile',
  },
  monthlyCostApproximateCostPerMonthMobile: {
    id: 'rahalaitos.fi.monthlyCostApproximateCostPerMonthMobile',
    defaultMessage: '<strong>{monthlyCost}</strong>/mth*',
    description: 'Shows the apprx. monthly cost on mobile',
  },
  monthlyCostApproximateCostLabelYears: {
    id: 'rahalaitos.fi.monthlyCostApproximateCostLabelYears',
    defaultMessage: 'in <strong> {repaymentTime} years </strong>',
    description: 'Repayment time in years',
  },
  combinedLoanConsolidationAmount: {
    id: 'rahalaitos.fi.combinedLoanConsolidationAmount',
    defaultMessage: 'Loans to consolidate:  {consolidationAmount}',
    description: 'Part of the loan that is consolidation amount',
  },
  samblaPlusText: {
    id: 'rahalaitos.fi.samblaPlusText',
    defaultMessage: 'I want to become a member of Sambla Plus to receive newsletters and offers via SMS and email. ',
    description: 'Text besides sambla plus checkbox in form',
  },
  samblaPlusReadMore: {
    id: 'rahalaitos.fi.samblaPlusReadMore',
    defaultMessage: 'Read more',
    description: 'Text for link to read about Sambla Plus',
  },
  termsAndIntegrityPolicyLinksIntegrityPolicy: {
    id: 'rahalaitos.fi.termsAndIntegrityPolicyLinksIntegrityPolicy',
    defaultMessage: 'user agreement',
    description: 'Text for link to user agreement policy',
  },
  termsAndIntegrityPolicyLinksTerms: {
    id: 'rahalaitos.fi.termsAndIntegrityPolicyLinksTerms',
    defaultMessage: 'Privacy Policy',
    description: 'Text for link to privacy policy',
  },
  repaymentTimeWarning: {
    id: 'rahalaitos.fi.repaymentTimeWarning',
    defaultMessage: 'Most lenders offer a maximum repayment time of 15 years. These banks offer a maximum of 15 years, even if you apply for longer than that.',
    description: 'warning when entering over 15 years repayment time',
  },
  loanCalculatorTotalLoanAmountLabel: {
    id: 'rahalaitos.fi.loanCalculator.totalLoanAmountLabel',
    defaultMessage: 'Loan amount',
    description: 'Label-text för totalbelopp av ett nuvarande kreditlån i formulär.',
  },
  loanCalculatorTotalLoanAmountPlaceholder: {
    id: 'rahalaitos.fi.loanCalculator.totalLoanAmountPlaceholder',
    defaultMessage: 'X XXX',
    description: 'Default-text för totalbelopp av ett nuvarande kreditlån i formulär.',
  },
  loanCalculatorTotalLoanAmountSuffix: {
    id: 'rahalaitos.fi.loanCalculator.totalLoanAmountSuffix',
    defaultMessage: '€',
    description: 'Suffix-text för totalbelopp av ett nuvarande kreditlån i formulär.',
  },
  loanCalculatorTotalLoanAmountTooltip: {
    id: 'rahalaitos.fi.loanCalculator.totalLoanAmountTooltip',
    defaultMessage: 'Please enter the total loan amount for the loan you want to use for calculation',
    description: 'Tooltip-text för totalbelopp av ett nuvarande kreditlån i formulär.',
  },
  loanCalculatorInterestRateLabel: {
    id: 'rahalaitos.fi.loanCalculator.interestRateLabel',
    defaultMessage: 'Interest rate',
    description: 'Label for interest rate.',
  },
  loanCalculatorInterestRatePlaceholder: {
    id: 'rahalaitos.fi.loanCalculator.interestRatePlaceholder',
    defaultMessage: 'X.XX',
    description: 'Default text for interest rate.',
  },
  loanCalculatorInterestRateSuffix: {
    id: 'rahalaitos.fi.loanCalculator.interestRateSuffix',
    defaultMessage: '%',
    description: 'Suffix for interest rate.',
  },
  loanCalculatorRepaymentTimeLabel: {
    id: 'rahalaitos.fi.loanCalculator.repaymentTimeLabel',
    defaultMessage: 'Repayment time',
    description: 'Label for repayment time inside form',
  },
  loanCalculatorRepaymentTimePlaceholder: {
    id: 'rahalaitos.fi.loanCalculator.repaymentTimePlaceholder',
    defaultMessage: '0',
    description: 'Default text for repayment time inside form',
  },
  loanCalculatorRepaymentTimeSuffix: {
    id: 'rahalaitos.fi.loanCalculator.repaymentTimeSuffix',
    defaultMessage: 'years',
    description: 'Suffix for repayment time inside form',
  },
  loanCalculatorSetUpFeeLabel: {
    id: 'rahalaitos.fi.loanCalculator.setUpFeeLabel',
    defaultMessage: 'Set-up Fee',
    description: 'Label text for start up fee.',
  },
  loanCalculatorSetUpFeePlaceholder: {
    id: 'rahalaitos.fi.loanCalculator.setUpFeePlaceholder',
    defaultMessage: '€ 30',
    description: 'Placeholder text for start up fee.',
  },
  loanCalculatorAviaFeeLabel: {
    id: 'rahalaitos.fi.loanCalculator.aviaFeeLabel',
    defaultMessage: 'Avia Fee',
    description: 'Label text for fee.',
  },
  loanCalculatorAviaFeePlaceholder: {
    id: 'rahalaitos.fi.loanCalculator.aviaFeePlaceholder',
    defaultMessage: '€ 3',
    description: 'Label text for avia fee.',
  },
  loanCalculatorNextSlideButtonHeading: {
    id: 'rahalaitos.fi.loanCalculator.nextSlideButtonHeading',
    defaultMessage: 'Do you want to apply for a loan based on the calculation above?',
    description: 'Title above the teleporter',
  },
  loanCalculatorNextSlideButtonSubHeading: {
    id: 'rahalaitos.fi.loanCalculator.nextSlideButtonSubHeading',
    defaultMessage: 'Fill out the information on the next page',
    description: 'Subtitle above the teleporter',
  },
  loanCalculatorNextSlideButton: {
    id: 'rahalaitos.fi.loanCalculator.nextSlideButton',
    defaultMessage: 'Next',
    description: 'general progress button label',
  },
  loanCalculatorAmortizationTypeLabel: {
    id: 'rahalaitos.fi.loanCalculator.summaryPage.amortizationTypeLabel',
    defaultMessage: 'Type of amortization',
    description: 'Label for which type of amortization the user wants to calculate with',
  },
  loanCalculatorAmortizationTypeAnnuity: {
    id: 'rahalaitos.fi.loanCalculator.summaryPage.amortizationTypeAnnuity',
    defaultMessage: 'Annuity',
    description: 'Text for amortization type annuity',
  },
  loanCalculatorAmortizationTypeStraight: {
    id: 'rahalaitos.fi.loanCalculator.summaryPage.amortizationTypeStraight',
    defaultMessage: 'Straight',
    description: 'Text for amortization type straight',
  },
  loanCalculatorTotalCostsForLoan: {
    id: 'rahalaitos.fi.loanCalculator.summaryPage.totalCostsForLoan',
    defaultMessage: 'Total cost',
    description: 'Text for total costs',
  },
  loanCalculatorTotalCostsAndInterestAndFeesForLoan: {
    id: 'rahalaitos.fi.loanCalculator.summaryPage.totalCostsAndInterestAndFeesForLoan',
    defaultMessage: 'Interest rate and fees',
    description: 'Text for total costs and interest and fees for loan',
  },
  loanCalculatorMonthlyCost: {
    id: 'rahalaitos.fi.loanCalculator.summaryPage.monthlyCost',
    defaultMessage: 'Monthly cost:',
    description: 'Text monthly cost',
  },
  loanCalculatorMonthlyCostMonthOne: {
    id: 'rahalaitos.fi.loanCalculator.summaryPage.monthlyCostMonthOne',
    defaultMessage: 'Monthly cost, month 1:',
    description: 'Text monthly cost',
  },
  loanCalculatorMonthlyCostOverviewButtonText: {
    id: 'rahalaitos.fi.loanCalculator.summaryPage.monthlyCostOverviewButtonText',
    defaultMessage: 'See overview of monthly cost',
    description: 'Text for button',
  },
  monthlySalaryTooltip: {
    id: 'rahalaitos.fi.monthlySalaryTooltip',
    defaultMessage: 'Please enter your total monthly income from all sources (€ before taxes). This may include salary, commission, and pension. Note that you might need to prove your stated income through payment slips and alike.',
    description: 'Tooltip-text för inkomst i formulär.',
  },
  coApplicantMonthlySalaryTooltip: {
    id: 'rahalaitos.fi.coApplicantMonthlySalaryTooltip',
    defaultMessage: "Enter your co-applicant's approximate total monthly income from all sources (€ before taxes). This may include salary, commission and pension. Note that your co-applicant might need to prove their stated income through payslips and alike.",
    description: 'Tooltip-text for coApplicant income in form.',
  },
  coApplicantNationalIdTooltip: {
    id: 'rahalaitos.fi.coApplicantNationalIdTooltip',
    defaultMessage: 'Since the application is personal, we need to verify your co-applicant’s national ID (don’t write your own). This needs to be a Finnish social security number',
    description: 'Tooltip-text for coApplicant in form.',
  },
  coApplicantEmploymentSinceYearTooltip: {
    id: 'rahalaitos.fi.coApplicantEmploymentSinceYearTooltip',
    defaultMessage: 'Please enter approximately the year when your co-applicant started at their current job. Use 4 numbers, e.g "2002".',
    description: 'Tooltip for "employment since"-input',
  },
  coApplicantEmploymentSinceMonthTooltip: {
    id: 'rahalaitos.fi.coApplicantEmploymentSinceMonthTooltip',
    defaultMessage: "Please select approximately the month that your co-applicant started at their current job. If you don't know exactly, pick what you think it is.",
    description: 'Tooltip for "employment since"-input',
  },
  loanCalculatorInterestRateTooltip: {
    id: 'rahalaitos.fi.loanCalculator.interestRateTooltip',
    defaultMessage: "The interest rate on loans can be seen as a monthly fee to the banks for lending you the money. Our partners' offered interest rate is decided based on your financial situation and can vary. You can read more about effective interest rate <a>here.</a>",
    description: 'Tooltip for interest rate for the loan in this form.',
  },
  loanCalculatorRepaymentTimeTooltip: {
    id: 'rahalaitos.fi.loanCalculator.repaymentTimeTooltip',
    defaultMessage: 'The repayment time refers to the amount of time you plan to pay back your loan. Depending on the time, the monthly cost of your loan might change, where a longer repayment time often means a lower monthly cost.',
    description: 'Tooltip for repayment time inside form, asking the applicant to fill in how long they wish to take to repay their loan. Also informing them that the longer time of repayment, the lower the monthly cost',
  },
  loanCalculatorSetUpFeeTooltip: {
    id: 'rahalaitos.fi.loanCalculator.setUpFeeTooltip',
    defaultMessage: 'Some banks have one single starting fee and/or recurring admin fees connected to your loan. You can find this info in the terms documentation of the loan or on the invoice.',
    description: 'Tooltip text for start up fee.',
  },
  loanCalculatorAviaFeeTooltip: {
    id: 'rahalaitos.fi.loanCalculator.aviaFeeTooltip',
    defaultMessage: 'Some banks have one single starting fee and/or recurring admin fees connected to your loan. You can find this info in the terms documentation of the loan or on the invoice.',
    description: 'Tooltip text for avia fee.',
  },
  loanCalculatorAmortizationTypeTooltip: {
    id: 'rahalaitos.fi.loanCalculator.summaryPage.amortizationTypeTooltip',
    defaultMessage: 'Amortization essentially means that you pay back a small portion of the loan every month. Sambla’s partners can provide either Annuity loans or Straight loans. Annuity loans are the most common and means you pay the same monthly cost every month. You can read more about amortization <a>here.</a>',
    description: 'Text for tooltip',
  },
  loanCalculatorTotalCostsForLoanTooltip: {
    id: 'rahalaitos.fi.loanCalculator.summaryPage.totalCostsForLoanTooltip',
    defaultMessage: 'You need to pay back the whole sum of the loan through the amortization plan, but there are also fees and interest costs connected to the loan that are added and needs to be paid.',
    description: 'Text for tooltip',
  },
  loanCalculatorTotalCostsAndInterestAndFeesForLoanTooltip: {
    id: 'rahalaitos.fi.loanCalculator.summaryPage.totalCostsAndInterestAndFeesForLoanTooltip',
    defaultMessage: 'These are the total fees, interest rate and costs connected to the loan. This excludes the loan amount, and with it, the amortization.',
    description: 'Text for tooltip',
  },
  loanCalculatorMonthlyCostTooltip: {
    id: 'rahalaitos.fi.loanCalculator.summaryPage.monthlyCostTooltip',
    defaultMessage: 'This is the recurring monthly cost for you until you have repaid your loan. Depending on your amortization type, these costs might change with time.',
    description: 'Text for tooltip',
  },
  bankAccountTooltip: {
    id: 'rahalaitos.fi.bankAccountTooltip',
    defaultMessage: 'Please enter your 16 digit IBAN number starting with FI. You can find this in your online bank under account details or by contacting your bank directly',
    description: 'Tooltip for bank account field',
  },
  coApplicantPrivateLoansTooltip: {
    id: 'rahalaitos.fi.coApplicantPrivateLoansTooltip',
    defaultMessage: 'Please enter the current debt of the co-applicant’s consumer/private loan/loans. Consumer loans are loans without security that can be used for anything - usually for consumption, renovation or paying other expensive debts. The banks and lenders need this information to get an overview of their financial situation and to be able to give out loan offers. Do not specify other debts in this field. ',
    description: 'private loans tooltip',
  },
  coApplicantCarLoansTooltip: {
    id: 'rahalaitos.fi.coApplicantCarLoansTooltip',
    defaultMessage: 'Please enter the current debt of the co-applicant’s car loan/loans. The banks and lenders need this information to get an overview of their financial situation and to be able to give out loan offers. Do not specify other debts in this field. Car loans are used to finance a car or a vehicle. It is a type of loan with security through the vehicle itself. These loans are often tied to the vehicle. ',
    description: 'car loans tooltip',
  },
  coApplicantHouseLoansTooltip: {
    id: 'rahalaitos.fi.coApplicantHouseLoansTooltip',
    defaultMessage: 'Please enter the current debt of the co-applicant’s mortgage. House loans/mortgages are loans used for financing the purchase of a property. These are loans with security through the property itself.The banks and lenders need this information to get an overview of their financial situation and to be able to give out loan offers. Do not specify other debts in this field.',
    description: 'House loans tooltip',
  },
  coApplicantStudentLoansTooltip: {
    id: 'rahalaitos.fi.coApplicantStudentLoansTooltip',
    defaultMessage: 'Please enter the current debt of the co-applicant’s student loan. The banks and lenders need this information to get an overview of their financial situation and to be able to give out loan offers. Do not specify other debts in this field. ',
    description: 'student loans tooltip',
  },
  coApplicantCreditCardLoansTooltip: {
    id: 'rahalaitos.fi.coApplicantCreditCardLoansTooltip',
    defaultMessage: 'Please enter the total debt of the co-applicant’s credit card/cards. The banks and lenders need this information to get an overview of their financial situation and to be able to give out loan offers. A credit card loan is money you borrow against your credit card limit. You can repay the entire debt per month or over a longer period of time. Do not specify other debts in this field.',
    description: 'Credit card loans tooltip',
  },
  isCoApplicantPepTooltip: {
    id: 'rahalaitos.fi.isCoApplicantPepTooltip',
    defaultMessage: 'Please enter yes if your co-applicant or anyone close to them is a person in a Politically Exposed Position. PEP is a person who has/had important public functions in a state/international organization. E.g. Head of state, head of government, ministers, deputy or assistant minister or members of parliaments.',
    description: 'Tooltip for if the coApplicant is a politically exposed person',
  },
  coApplicantCreditCardTooltip: {
    id: 'rahalaitos.fi.coApplicantCreditCardTooltip',
    defaultMessage: 'Does your co-applicant have any active credit cards?',
    description: 'Tooltip for if the coApplicant have credit cards',
  },
  coApplicantOtherIncomeTooltip: {
    id: 'rahalaitos.fi.coApplicantOtherIncomeTooltip',
    defaultMessage: 'Does the co-applicant have additional sources of income that are not stated already? This may include for example income from letting an apartment, income from a hobby, or state allowance. They need to prove their additional income through tax or payment slips',
    description: 'Tooltip for coApplicant has other income',
  },
  loanCalculatorSummaryTablePageDescription: {
    id: 'rahalaitos.fi.loanCalculator.summaryPage.summaryTablePageDescription',
    defaultMessage: 'More info',
    description: 'Text for page description',
  },
  loanCalculatorEffectiveInterest: {
    id: 'rahalaitos.fi.loanCalculator.summaryPage.effectiveInterest',
    defaultMessage: 'Effective interest rate:',
    description: 'Text for summary table effective interest',
  },
  loanCalculatorSummaryTableColumnMonth: {
    id: 'rahalaitos.fi.loanCalculator.summaryPage.summaryTableColumnMonth',
    defaultMessage: 'Month',
    description: 'Text for summary table month column',
  },
  loanCalculatorSummaryTableColumnDebtBeforeAmortization: {
    id: 'rahalaitos.fi.loanCalculator.summaryPage.summaryTableColumnDebtBeforeAmortization',
    defaultMessage: 'Debt before amortization',
    description: 'Text for summary table debt before amortization column',
  },
  loanCalculatorSummaryTableColumnAmortization: {
    id: 'rahalaitos.fi.loanCalculator.summaryPage.summaryTableColumnAmortization',
    defaultMessage: 'Amortization',
    description: 'Text for summary table amortization column',
  },
  loanCalculatorSummaryTableColumnInterestCost: {
    id: 'rahalaitos.fi.loanCalculator.summaryPage.summaryTableColumnInterestCost',
    defaultMessage: 'Interest rate',
    description: 'Text for summary table interest cost column',
  },
  loanCalculatorSummaryTableColumnFeeCost: {
    id: 'rahalaitos.fi.loanCalculator.summaryPage.summaryTableColumnFeeCost',
    defaultMessage: 'Fees',
    description: 'Text for summary table fee cost column',
  },
  loanCalculatorSummaryTableColumnToPay: {
    id: 'rahalaitos.fi.loanCalculator.summaryPage.summaryTableColumnToPay',
    defaultMessage: 'To pay',
    description: 'Text for summary table to pay column',
  },
  loanCalculatorCurrencySuffix: {
    id: 'rahalaitos.fi.loanCalculator.summaryPage.currencySuffix',
    defaultMessage: '€',
    description: 'Suffix text for amounts in the loan calculator etc. kr or €',
  },
  feesCostRequired: {
    id: 'rahalaitos.fi.loanCalculator.feesCostRequired',
    defaultMessage: 'Please enter the fee',
    description: 'Fee description',
  },
  feesCostOnlyDigits: {
    id: 'rahalaitos.fi.loanCalculator.feesCostOnlyDigits',
    defaultMessage: 'Please write your fees cost in numbers only',
    description: 'Inform the customer that they may only pass in digits in the input for the fees cost.',
  },
  feesCostTooHigh: {
    id: 'rahalaitos.fi.loanCalculator.feesCostTooHigh',
    defaultMessage: 'Your fees cost cannot be more than € {maxCost, number} /mth.',
    description: 'Inform the customer that we may unfortunately only accept a fees cost of "x" and that their cost is to high',
  },
  feesCostTooLow: {
    id: 'rahalaitos.fi.loanCalculator.feesCostTooLow',
    defaultMessage: 'Please enter the fees connected to the loan',
    description: 'Inform the customer that their passed in fees cost is set to low, for example "0"',
  },
  feesCostStartWithZero: {
    id: 'rahalaitos.fi.loanCalculator.feesCostStartWithZero',
    defaultMessage: "Please don't start your input with a 0",
    description: 'Inform the customer that their passed in fees cost is set to low, for example "0"',
  },
  citizenshipLabel: {
    id: 'rahalaitos.fi.citizenshipLabel',
    defaultMessage: 'Citizenship',
    description: 'Label for citizen section',
  },
  citizenshipPlaceholder: {
    id: 'rahalaitos.fi.citizenshipPlaceholder',
    defaultMessage: 'Choose',
    description: 'Placeholder for citizenship section',
  },
  coApplicantCitizenshipLabel: {
    id: 'rahalaitos.fi.coApplicantCitizenshipLabel',
    defaultMessage: "Co-applicant's citizenship",
    description: 'Label for coapplicant citizen section',
  },
  coApplicantCitizenshipPlaceholder: {
    id: 'rahalaitos.fi.coApplicantCitizenshipPlaceholder',
    defaultMessage: 'Choose',
    description: 'Placeholder for co-applicant citizenship',
  },
  citizenshipFIN: {
    id: 'rahalaitos.fi.citizenshipFIN',
    defaultMessage: 'Finland',
    description: 'Option for citizenship',
  },
  citizenshipSWE: {
    id: 'rahalaitos.fi.citizenshipSWE',
    defaultMessage: 'Sweden',
    description: 'Option for citizenship',
  },
  citizenshipRUS: {
    id: 'rahalaitos.fi.citizenshipRUS',
    defaultMessage: 'Russia',
    description: 'Option for citizenship',
  },
  citizenshipEST: {
    id: 'rahalaitos.fi.citizenshipEST',
    defaultMessage: 'Estonia',
    description: 'Option for citizenship',
  },
  citizenshipOther: {
    id: 'rahalaitos.fi.citizenshipOther',
    defaultMessage: 'Other',
    description: 'Option for citizenship',
  },
  moveInDateRequiredYear: {
    id: 'rahalaitos.fi.moveInDateRequiredYear',
    defaultMessage: 'Please enter the year you moved to your current home',
    description: 'Asking customer when they moved to their current home',
  },
  coAppMoveInDateYear: {
    id: 'rahalaitos.fi.coAppMoveInDateYear',
    defaultMessage: 'Please enter the year your co-applicant moved to their current home',
    description: 'Asking customer when their co-applicant moved to their current home',
  },
  moveInDateOnlyNumbers: {
    id: 'rahalaitos.fi.moveInDateOnlyNumbers',
    defaultMessage: 'Please enter the year in digits (e.g. 2010).',
    description: 'Error message informing the applicant that they may only use digits when filling in which year they moved to Finland',
  },
  moveInDateFourDigits: {
    id: 'rahalaitos.fi.moveInDateFourDigits',
    defaultMessage: 'Please write the year in 4 digits, e.g. 2010.',
    description: 'Error message informing the applicant that the format for "year they moved to Finland" should be filled in with four digits',
  },
  moveInDateTooFarBack: {
    id: 'rahalaitos.fi.moveInDateTooFarBack',
    defaultMessage: 'Enter the year you moved to your current home (e.g. 2010).',
    description: 'Error message informing the applicant that the year they moved to their current home is set to far back in time',
  },
  coApplicantMoveInDateTooFarBack: {
    id: 'rahalaitos.fi.coApplicant.coApplicantMoveInDateTooFarBack',
    defaultMessage: 'Enter the year they moved to their current home (e.g. 2010).',
    description: 'Error message informing the coapplicant moved to their current home is to far back in time',
  },
  moveInDateInTheFuture: {
    id: 'rahalaitos.fi.moveInDateInTheFuture',
    defaultMessage: 'Your move date cannot be in the future',
    description: 'Error message informing the applicant that their "move to Finland date" cannot be set to a date in the future',
  },
  coAppMoveInDateInTheFuture: {
    id: 'rahalaitos.fi.coAppMoveInDateInTheFuture',
    defaultMessage: 'Their move date cannot be in the future.',
    description: 'Error message informing the coapplicant that their "move to Finland date" cannot be set to a date in the future',
  },
  inFICountrySinceLabel: {
    id: 'rahalaitos.fi.inFICountrySinceLabel',
    defaultMessage: 'What year did you move to Finland?',
    description: 'Asking customer how long they have been in fi',
  },
  inFICountrySincePlaceholder: {
    id: 'rahalaitos.fi.inFICountrySincePlaceholder',
    defaultMessage: 'In country since (year)',
    description: 'Asking customer how long they have been in fi - placeholder',
  },
  inFICountrySinceRequiredYear: {
    id: 'rahalaitos.fi.inFICountrySinceRequiredYear',
    defaultMessage: 'Please enter the year you moved to Finland',
    description: 'Asking customer when they moved to Finland',
  },
  inFICountrySinceOnlyNumbers: {
    id: 'rahalaitos.fi.inFICountrySinceOnlyNumbers',
    defaultMessage: 'Please enter the year in digits (e.g. 2010).',
    description: 'Error message informing the applicant that they may only use digits when filling in which year they moved to Finland',
  },
  inFICountrySinceFourDigits: {
    id: 'rahalaitos.fi.inFICountrySinceFourDigits',
    defaultMessage: 'Please write the year in 4 digits, e.g. 2010.',
    description: 'Error message informing the applicant that the format for "year they moved to Finland" should be filled in with four digits',
  },
  inFICountrySinceTooFarBack: {
    id: 'rahalaitos.fi.inFICountrySinceTooFarBack',
    defaultMessage: 'Enter the year you moved to Finland (e.g. 2010).',
    description: 'Error message informing the applicant that the year they moved to Finalnd is set to far back in time',
  },
  coApplicantInFICountrySinceTooFarBack: {
    id: 'rahalaitos.fi.coApplicant.coApplicantInFICountrySinceTooFarBack',
    defaultMessage: 'Enter the year they moved to Finland (e.g. 2010).',
    description: 'Error message informing the coapplicant moved to Finland is to far back in time',
  },
  inFICountrySinceInTheFuture: {
    id: 'rahalaitos.fi.inFICountrySinceInTheFuture',
    defaultMessage: 'Your move date cannot be in the future',
    description: 'Error message informing the applicant that their "move to Finland date" cannot be set to a date in the future',
  },
  coAppInFICountrySinceRequiredYear: {
    id: 'rahalaitos.fi.coAppInFICountrySinceRequiredYear',
    defaultMessage: 'Please enter the year your co-applicant moved to Finland',
    description: 'Asking customer when their co-applicant moved to Finland',
  },
  coAppInFICountrySinceInTheFuture: {
    id: 'rahalaitos.fi.coAppInFICountrySinceInTheFuture',
    defaultMessage: 'Their move date cannot be in the future.',
    description: 'Error message informing the coapplicant that their "move to Finland date" cannot be set to a date in the future',
  },
  inFICountrySincePlaceholderMonth: {
    id: 'rahalaitos.fi.inFICountrySincePlaceholderMonth',
    defaultMessage: 'In country since (month)',
    description: 'Asking customer how long they have been in fi - placeholder',
  },
  inFICountrySinceLabelMonth: {
    id: 'rahalaitos.fi.inFICountrySinceLabelMonth',
    defaultMessage: 'Month',
    description: 'Asking customer how long they have been in fi - placeholder',
  },
  inFICountrySinceRequiredMonth: {
    id: 'rahalaitos.fi.inFICountrySinceRequiredMonth',
    defaultMessage: 'Please enter the month you moved to Finland',
    description: 'Error message informing the applicant that they must pass in which month they moved to Finland',
  },
  inFICountrySinceTimeInTheFutureMonth: {
    id: 'rahalaitos.fi.inFICountrySinceTimeInTheFutureMonth',
    defaultMessage: 'The move date cannot be in the future',
    description: 'Error message informing the start date is in the future',
  },
  coAppInFICountrySinceRequiredMonth: {
    id: 'rahalaitos.fi.coApplicant.coAppInFICountrySinceRequiredMonth',
    defaultMessage: 'Please enter the month your co-applicant moved to Finland',
    description: 'Error message informing the coapplicant that they must pass in which month they moved to Finland',
  },
  coApplicantInFICountrySinceLabel: {
    id: 'rahalaitos.fi.coApplicantInFICountrySinceLabel',
    defaultMessage: 'What year did they move to Finland?',
    description: 'Asking customer how long the coapplicant has been in fi',
  },
  coApplicantInFICountrySincePlaceholder: {
    id: 'rahalaitos.fi.coApplicantInFICountrySincePlaceholder',
    defaultMessage: 'E.g 2002',
    description: 'Asking customer how long the coapplicant has been in fi - placeholder',
  },
  coApplicantInFICountrySincePlaceholderMonth: {
    id: 'rahalaitos.fi.coApplicantInFICountrySincePlaceholderMonth',
    defaultMessage: 'E.g 2002',
    description: 'Asking customer how long the coapplicant has been in fi - placeholder',
  },
  coApplicantInFICountrySinceLabelMonth: {
    id: 'rahalaitos.fi.coApplicantInFICountrySinceLabelMonth',
    defaultMessage: 'Month',
    description: 'Asking customer how long the coapplicant has been in fi - placeholder',
  },
  moveInDateLabel: {
    id: 'rahalaitos.fi.moveInDateLabel',
    defaultMessage: 'When did you move to your address? (year)',
    description: 'Asking customer how long they have lived in on this address',
  },
  moveInDateLabelCoApplicant: {
    id: 'rahalaitos.fi.moveInDateLabelCoApplicant',
    defaultMessage: 'When did your co-applicant move to their address? (year)',
    description: 'Asking customer how long they have lived in on this address',
  },
  moveInDatePlaceholder: {
    id: 'rahalaitos.fi.moveInDatePlaceholder',
    defaultMessage: 'E.g 2002',
    description: 'Asking customer how long they have lived in on this address',
  },
  moveInDatePlaceholderCoApplicant: {
    id: 'rahalaitos.fi.moveInDatePlaceholderCoApplicant',
    defaultMessage: 'E.g 2002',
    description: 'Asking customer how long they have lived in on this address',
  },
  bankAccountLabel: {
    id: 'rahalaitos.fi.bankAccountLabel',
    defaultMessage: 'Account number (IBAN)',
    description: 'Label for bank account field',
  },
  bankAccountPlaceholder: {
    id: 'rahalaitos.fi.bankAccountPlaceholder',
    defaultMessage: 'Bank account (IBAN)',
    description: 'Placeholder for bank account field',
  },
  educationLabel: {
    id: 'rahalaitos.fi.educationLabel',
    defaultMessage: 'Education',
    description: 'Label for education section',
  },
  educationPlaceholder: {
    id: 'rahalaitos.fi.educationPlaceholder',
    defaultMessage: 'Choose',
    description: 'Placeholder for education section',
  },
  educationTypePrimarySchool: {
    id: 'rahalaitos.fi.educationTypePrimarySchool',
    defaultMessage: 'Primary school',
    description: 'education type - primary school',
  },
  educationTypeHighSchool: {
    id: 'rahalaitos.fi.educationTypeHighSchool',
    defaultMessage: 'High school',
    description: 'education type - high school',
  },
  educationTypeBachelor: {
    id: 'rahalaitos.fi.educationTypeBachelor',
    defaultMessage: 'Bachelor',
    description: 'education type - bachelor',
  },
  educationTypeCollege: {
    id: 'rahalaitos.fi.educationTypeCollege',
    defaultMessage: 'College',
    description: 'education type - college',
  },
  educationTypeMasters: {
    id: 'rahalaitos.fi.educationTypeMasters',
    defaultMessage: 'Masters',
    description: 'education type - masters degree',
  },
  coApplicantEducationLabel: {
    id: 'rahalaitos.fi.coApplicantEducationLabel',
    defaultMessage: 'Co-applicant’s Education',
    description: 'Label for coapplicant education section',
  },
  coApplicantEducationPlaceholder: {
    id: 'rahalaitos.fi.coApplicantEducationPlaceholder',
    defaultMessage: 'Choose',
    description: 'Placeholder for coapplicant education section',
  },
  occupationLabel: {
    id: 'rahalaitos.fi.occupationLabel',
    defaultMessage: 'Occupation',
    description: 'occupation label',
  },
  workPositionLabel: {
    id: 'rahalaitos.fi.workPositionLabel',
    defaultMessage: 'Work Position',
    description: 'occupation label',
  },
  occupationPlaceholder: {
    id: 'rahalaitos.fi.occupationPlaceholder',
    defaultMessage: 'Occupation',
    description: 'occupation placeholder',
  },
  coApplicantOccupationLabel: {
    id: 'rahalaitos.fi.coApplicantOccupationLabel',
    defaultMessage: 'Co-applicant’s occupation category',
    description: 'Label for co-applicant occupation category',
  },
  coApplicantOccupationPlaceholder: {
    id: 'rahalaitos.fi.coApplicantOccupationPlaceholder',
    defaultMessage: 'Choose',
    description: 'Placeholder for co-applicant occupation category',
  },
  occupationCategoryLabel: {
    id: 'rahalaitos.fi.occupationCategoryLabel',
    defaultMessage: 'Occupation category',
    description: 'Occupation category - label',
  },
  occupationCategoryPlaceholder: {
    id: 'rahalaitos.fi.occupationCategoryPlaceholder',
    defaultMessage: 'Choose',
    description: 'Placeholder for occupation category',
  },
  coApplicantOccupationTitleLabel: {
    id: 'rahalaitos.fi.coApplicantOccupationTitleLabel',
    defaultMessage: 'Co-applicant´s occupation title',
    description: 'Occupation title - label',
  },
  occupationTitleLabel: {
    id: 'rahalaitos.fi.occupationTitleLabel',
    defaultMessage: 'Occupation title',
    description: 'Occupation title - label',
  },
  occupationTitlePlaceholder: {
    id: 'rahalaitos.fi.occupationTitlePlaceholder',
    defaultMessage: 'E.g project manager',
    description: 'Occupation title - placeholder',
  },
  occupationCategoryEntrepreneur: {
    id: 'rahalaitos.fi.occupationCategoryEntrepreneur',
    defaultMessage: 'Entrepreneur',
    description: 'Occupation category - Entrepreneur',
  },
  occupationCategorySeniorClerk: {
    id: 'rahalaitos.fi.occupationCategorySeniorClerk',
    defaultMessage: 'Senior official',
    description: 'Occupation category - senior official',
  },
  occupationCategoryLowerEmployee: {
    id: 'rahalaitos.fi.occupationCategoryLowerEmployee',
    defaultMessage: 'Junior employee',
    description: 'Occupation category - Lower employee',
  },
  occupationCategoryEmployee: {
    id: 'rahalaitos.fi.occupationCategoryEmployee',
    defaultMessage: 'Employee',
    description: 'Occupation category - Employee',
  },
  occupationCategoryFarmer: {
    id: 'rahalaitos.fi.occupationCategoryFarmer',
    defaultMessage: 'Farmer',
    description: 'Occupation category - Farmer',
  },
  occupationCategoryStudent: {
    id: 'rahalaitos.fi.occupationCategoryStudent',
    defaultMessage: 'Student',
    description: 'Occupation category - Student',
  },
  occupationCategoryLeadership: {
    id: 'rahalaitos.fi.occupationCategoryLeadership',
    defaultMessage: 'Leadership',
    description: 'Occupation category - Leadership',
  },
  occupationCategoryPensioner: {
    id: 'rahalaitos.fi.occupationCategoryPensioner',
    defaultMessage: 'Pensioner',
    description: 'Occupation category - Pensioner',
  },
  studentSinceYearDynamicLabel: {
    id: 'rahalaitos.fi.studentSinceYearDynamicLabel',
    defaultMessage: 'Student since (year)',
    description: 'Label for employed since if student',
  },
  selfEmployedEmployerNameDynamicLabel: {
    id: 'rahalaitos.fi.selfEmployedEmployerNameDynamicLabel',
    defaultMessage: 'Name of company',
    description: 'Label for employer if self employed',
  },
  selfEmployedSinceYearDynamicLabel: {
    id: 'rahalaitos.fi.selfEmployedSinceYearDynamicLabel',
    defaultMessage: 'Self employed since (year)',
    description: 'Label for employed since year if self employed',
  },
  selfEmployedSinceMonthDynamicLabel: {
    id: 'rahalaitos.fi.selfEmployedSinceMonthDynamicLabel',
    defaultMessage: 'Self employed since (month)',
    description: 'Label for employed since month if self employed',
  },
  studentSinceMonthDynamicLabel: {
    id: 'rahalaitos.fi.studentSinceMonthDynamicLabel',
    defaultMessage: 'Student since (month)',
    description: 'Label for employed since month if student',
  },
  studentSinceDynamicLabel: {
    id: 'rahalaitos.fi.studentSinceDynamicLabel',
    defaultMessage: 'Student since (year)',
    description: 'Label for employed since if student',
  },
  occupationCategoryOther: {
    id: 'rahalaitos.fi.occupationCategoryOther',
    defaultMessage: 'Other',
    description: 'Occupation category - Other',
  },
  militaryTypeLabel: {
    id: 'rahalaitos.fi.militaryTypeLabel',
    defaultMessage: 'Military service',
    description: 'Military Type - Executed',
  },
  militaryTypePlaceholder: {
    id: 'rahalaitos.fi.militaryTypePlaceholder',
    defaultMessage: 'Choose',
    description: 'Placeholder for military type',
  },
  militaryTypeExecuted: {
    id: 'rahalaitos.fi.militaryTypeExecuted',
    defaultMessage: 'Completed',
    description: 'Military Type - Executed',
  },
  militaryTypeNotCompleted: {
    id: 'rahalaitos.fi.militaryTypeNotCompleted',
    defaultMessage: 'Not completed',
    description: 'Military Type - Not Executed',
  },
  militaryTypeReleased: {
    id: 'rahalaitos.fi.militaryTypeReleased',
    defaultMessage: 'Released',
    description: 'Military Type - Released',
  },
  militaryTypeNotApplicable: {
    id: 'rahalaitos.fi.militaryTypeNotApplicable',
    defaultMessage: 'Not Applicable',
    description: 'Military Type - Not Applicable',
  },
  coApplicantMilitaryTypeLabel: {
    id: 'rahalaitos.fi.coApplicantMilitaryTypeLabel',
    defaultMessage: 'Co-applicant’s Military service',
    description: 'Military Type - Executed',
  },
  coApplicantMilitaryTypePlaceholder: {
    id: 'rahalaitos.fi.coApplicantMilitaryTypePlaceholder',
    defaultMessage: 'Choose',
    description: 'Placeholder for military type',
  },
  privateLoansLabel: {
    id: 'rahalaitos.fi.privateLoansLabel',
    defaultMessage: 'Do you have consumer loans?',
    description: 'private loans question/label',
  },
  privateLoansAmountLabel: {
    id: 'rahalaitos.fi.privateLoansAmountLabel',
    defaultMessage: 'Consumer loan amount (€)',
    description: 'private loans amount',
  },
  privateLoansAmountPlaceholder: {
    id: 'rahalaitos.fi.privateLoansAmountPlaceholder',
    defaultMessage: 'Consumer loan amount (€)',
    description: 'private loans amount',
  },
  privateLoansMonthlyCostPlaceholder: {
    id: 'rahalaitos.fi.privateLoansMonthlyCostPlaceholder',
    defaultMessage: 'Consumer loan monthly cost (€/mth)',
    description: 'private loans monthly cost',
  },
  privateLoansMonthlyCostLabel: {
    id: 'rahalaitos.fi.privateLoansMonthlyCostLabel',
    defaultMessage: 'Consumer loan monthly cost (€/mth)',
    description: 'private loans monthly cost',
  },
  creditLoansLabel: {
    id: 'rahalaitos.fi.creditLoansLabel',
    defaultMessage: 'Do you have credit loans? (€)',
    description: 'Asking customer if they have credit loans',
  },
  creditLoansAmountLabel: {
    id: 'rahalaitos.fi.creditLoansAmountLabel',
    defaultMessage: 'Credit loan amount (€)',
    description: 'Credit loan amount label',
  },
  creditLoansAmountPlaceholder: {
    id: 'rahalaitos.fi.creditLoansAmountPlaceholder',
    defaultMessage: 'Credit loan amount (€)',
    description: 'Credit loan amount placeholder',
  },
  creditLoansMonthlyCostLabel: {
    id: 'rahalaitos.fi.creditLoansMonthlyCostLabel',
    defaultMessage: 'Credit loan monthly cost (€/mth)',
    description: 'Credit loan monthly cost label',
  },
  creditLoansMonthlyCostPlaceholder: {
    id: 'rahalaitos.fi.creditLoansMonthlyCostPlaceholder',
    defaultMessage: 'Credit loan monthly cost (€/mth)',
    description: 'Credit loan monthly cost placeholder',
  },
  houseLoansLabel: {
    id: 'rahalaitos.fi.houseLoansLabel',
    defaultMessage: 'Do you have any house loans?',
    description: 'House loan label/questions',
  },
  houseLoansAmountLabel: {
    id: 'rahalaitos.fi.houseLoansAmountLabel',
    defaultMessage: 'House loans amount (€)',
    description: 'House loan amount label',
  },
  houseLoansAmountPlaceholder: {
    id: 'rahalaitos.fi.houseLoansAmountPlaceholder',
    defaultMessage: 'House loans amount (€)',
    description: 'House loan amount placeholder',
  },
  houseLoansMonthlyCostLabel: {
    id: 'rahalaitos.fi.houseLoansMonthlyCostLabel',
    defaultMessage: 'House loans monthly cost (€/mth)',
    description: 'House loan MonthlyCost label',
  },
  houseLoansMonthlyCostPlaceholder: {
    id: 'rahalaitos.fi.houseLoansMonthlyCostPlaceholder',
    defaultMessage: 'House loans monthly cost (€/mth)',
    description: 'House loan MonthlyCost placeholder',
  },
  houseLoansPartLabel: {
    id: 'rahalaitos.fi.houseLoansPartLabel',
    defaultMessage: 'How much is shared with your partner?',
    description: 'Asking customer how much of the house loan they pay',
  },
  houseLoansLoanIsOwnedByApplicant: {
    id: 'rahalaitos.fi.houseLoansLoanIsOwnedByApplicant',
    defaultMessage: 'I am responsible',
    description: 'Text for applicant is owning the loan',
  },
  houseLoansPartHalf: {
    id: 'rahalaitos.fi.houseLoansPartHalf',
    defaultMessage: '50%',
    description: 'Paying 50% of the house loan',
  },
  houseLoansLoanIsSharedWithCoApplicant: {
    id: 'rahalaitos.fi.houseLoansLoanIsSharedWithCoApplicant',
    defaultMessage: 'Shared responsibility',
    description: 'Text for the house loan is shared with co applicant',
  },
  carLoansLabel: {
    id: 'rahalaitos.fi.carLoansLabel',
    defaultMessage: 'Do you have car loans?',
    description: 'Asking customer if they have car loans',
  },
  carLoansAmountLabel: {
    id: 'rahalaitos.fi.carLoansAmountLabel',
    defaultMessage: 'Car loans total amount (€)',
    description: 'Label car loans amount',
  },
  carLoansAmountPlaceholder: {
    id: 'rahalaitos.fi.carLoansAmountPlaceholder',
    defaultMessage: 'Car loans total amount (€)',
    description: 'Placeholder car loans amount',
  },
  carLoansMonthlyCostLabel: {
    id: 'rahalaitos.fi.carLoansMonthlyCostLabel',
    defaultMessage: 'Car loans monthly cost (€/mth)',
    description: 'Label car loans monthly cost',
  },
  carLoansMonthlyCostPlaceholder: {
    id: 'rahalaitos.fi.carLoansMonthlyCostPlaceholder',
    defaultMessage: 'Car loans monthly cost (€/mth)',
    description: 'Placeholder car loans monthly cost',
  },
  studentLoansLabel: {
    id: 'rahalaitos.fi.studentLoansLabel',
    defaultMessage: 'Do you have student loans? (€)',
    description: 'Asking customer if they have student loans',
  },
  studentLoansAmountLabel: {
    id: 'rahalaitos.fi.studentLoansAmountLabel',
    defaultMessage: 'Student loans total amount (€)',
    description: 'Label student loans amount',
  },
  studentLoansAmountPlaceholder: {
    id: 'rahalaitos.fi.studentLoansAmountPlaceholder',
    defaultMessage: 'Student loans total amount (€)',
    description: 'Placeholder student loans amount',
  },
  studentLoansMonthlyCostLabel: {
    id: 'rahalaitos.fi.studentLoansMonthlyCostLabel',
    defaultMessage: 'Student loans monthly cost (€/mth)',
    description: 'Label student loans monthly cost',
  },
  studentLoansMonthlyCostPlaceholder: {
    id: 'rahalaitos.fi.studentLoansMonthlyCostPlaceholder',
    defaultMessage: 'Student loans monthly cost (€/mth)',
    description: 'Placeholder student loans monthly cost',
  },
  isPepLabel: {
    id: 'rahalaitos.fi.isPepLabel',
    defaultMessage: 'Are you, or anyone close to you, a politically exposed person?',
    description: 'Asking customer if they are politically exposed',
  },
  coApplicantPrivateLoansLabel: {
    id: 'rahalaitos.fi.coApplicantPrivateLoansLabel',
    defaultMessage: 'Does your co-applicant have consumer loans?',
    description: 'private loans question/label',
  },
  coApplicantPrivateLoansAmountLabel: {
    id: 'rahalaitos.fi.coApplicantPrivateLoansAmountLabel',
    defaultMessage: 'Consumer loan amount (€)',
    description: 'private loans amount',
  },
  coApplicantPrivateLoansAmountPlaceholder: {
    id: 'rahalaitos.fi.coApplicantPrivateLoansAmountPlaceholder',
    defaultMessage: 'Consumer loan amount (€)',
    description: 'private loans amount',
  },
  coApplicantPrivateLoansMonthlyCostPlaceholder: {
    id: 'rahalaitos.fi.coApplicantPrivateLoansMonthlyCostPlaceholder',
    defaultMessage: 'Consumer loan monthly cost (€/mth)',
    description: 'private loans monthly cost',
  },
  coApplicantPrivateLoansMonthlyCostLabel: {
    id: 'rahalaitos.fi.coApplicantPrivateLoansMonthlyCostLabel',
    defaultMessage: 'Consumer loan monthly cost (€/mth)',
    description: 'private loans monthly cost',
  },
  coApplicantCreditLoansLabel: {
    id: 'rahalaitos.fi.coApplicantCreditLoansLabel',
    defaultMessage: 'Does your co-applicant have credit loans?',
    description: 'Asking customer if they have credit loans',
  },
  coApplicantCreditLoansAmountLabel: {
    id: 'rahalaitos.fi.coApplicantCreditLoansAmountLabel',
    defaultMessage: 'Credit loan amount (€)',
    description: 'Credit loan amount label',
  },
  coApplicantCreditLoansAmountPlaceholder: {
    id: 'rahalaitos.fi.coApplicantCreditLoansAmountPlaceholder',
    defaultMessage: 'Credit loan amount (€)',
    description: 'Credit loan amount placeholder',
  },
  coApplicantCreditLoansMonthlyCostLabel: {
    id: 'rahalaitos.fi.coApplicantCreditLoansMonthlyCostLabel',
    defaultMessage: 'Credit loan monthly cost (€/mth)',
    description: 'Credit loan monthly cost label',
  },
  coApplicantCreditLoansMonthlyCostPlaceholder: {
    id: 'rahalaitos.fi.coApplicantCreditLoansMonthlyCostPlaceholder',
    defaultMessage: 'Credit loan monthly cost (€/mth)',
    description: 'Credit loan monthly cost placeholder',
  },
  coApplicantHouseLoansLabel: {
    id: 'rahalaitos.fi.coApplicantHouseLoansLabel',
    defaultMessage: 'Does your co-applicant have any house loans?',
    description: 'House loan label/questions',
  },
  coApplicantHuseLoansAmountLabel: {
    id: 'rahalaitos.fi.coApplicantHouseLoansAmountLabel',
    defaultMessage: 'House loans amount (€)',
    description: 'House loan amount label',
  },
  coApplicantHouseLoansAmountPlaceholder: {
    id: 'rahalaitos.fi.coApplicantHouseLoansAmountPlaceholder',
    defaultMessage: 'House loans amount (€)',
    description: 'House loan amount placeholder',
  },
  coApplicantHouseLoansMonthlyCostLabel: {
    id: 'rahalaitos.fi.coApplicantHouseLoansMonthlyCostLabel',
    defaultMessage: 'House loans monthly cost (€/mth)',
    description: 'House loan MonthlyCost label',
  },
  coApplicantHouseLoansMonthlyCostPlaceholder: {
    id: 'rahalaitos.fi.coApplicantHouseLoansMonthlyCostPlaceholder',
    defaultMessage: 'House loans monthly cost (€/mth)',
    description: 'House loan MonthlyCost placeholder',
  },
  coApplicantHouseLoansPartLabel: {
    id: 'rahalaitos.fi.coApplicantHouseLoansPartLabel',
    defaultMessage: 'How much is shared with their partner?',
    description: 'Asking customer how much of the house loan they pay',
  },
  coApplicantCarLoansLabel: {
    id: 'rahalaitos.fi.coApplicantCarLoansLabel',
    defaultMessage: 'Does your co-applicant have car loans?',
    description: 'Asking customer if they have car loans',
  },
  coApplicantCarLoansAmountLabel: {
    id: 'rahalaitos.fi.coApplicantCarLoansAmountLabel',
    defaultMessage: 'Car loans amount (€)',
    description: 'Label car loans amount',
  },
  coApplicantCarLoansAmountPlaceholder: {
    id: 'rahalaitos.fi.coApplicantCarLoansAmountPlaceholder',
    defaultMessage: 'Car loans amount (€)',
    description: 'Placeholder car loans amount',
  },
  coApplicantCarLoansMonthlyCostLabel: {
    id: 'rahalaitos.fi.coApplicantCarLoansMonthlyCostLabel',
    defaultMessage: 'Car loans monthly cost (€/mth)',
    description: 'Label car loans monthly cost',
  },
  coApplicantCarLoansMonthlyCostPlaceholder: {
    id: 'rahalaitos.fi.coApplicantCarLoansMonthlyCostPlaceholder',
    defaultMessage: 'Car loans monthly cost (€/mth)',
    description: 'Placeholder car loans monthly cost',
  },
  coApplicantStudentLoansLabel: {
    id: 'rahalaitos.fi.coApplicantStudentLoansLabel',
    defaultMessage: 'Does your co-applicant have student loans?',
    description: 'Asking customer if they have student loans',
  },
  coApplicantStudentLoansAmountLabel: {
    id: 'rahalaitos.fi.coApplicantStudentLoansAmountLabel',
    defaultMessage: 'Student loans amount (€)',
    description: 'Label student loans amount',
  },
  coApplicantStudentLoansAmountPlaceholder: {
    id: 'rahalaitos.fi.coApplicantStudentLoansAmountPlaceholder',
    defaultMessage: 'Student loans amount (€)',
    description: 'Placeholder student loans amount',
  },
  coApplicantStudentLoansMonthlyCostLabel: {
    id: 'rahalaitos.fi.coApplicantStudentLoansMonthlyCostLabel',
    defaultMessage: 'Student loans monthly cost (€/mth)',
    description: 'Label student loans monthly cost',
  },
  coApplicantStudentLoansMonthlyCostPlaceholder: {
    id: 'rahalaitos.fi.coApplicantStudentLoansMonthlyCostPlaceholder',
    defaultMessage: 'Student loans monthly cost (€/mth)',
    description: 'Placeholder student loans monthly cost',
  },
  isCoApplicantPepLabel: {
    id: 'rahalaitos.fi.isCoApplicantPepLabel',
    defaultMessage: 'Is your co-applicant, or anyone close to them, a politically exposed person?',
    description: 'Asking customer if the coApplicant is a politically exposed person',
  },
  creditCardLabel: {
    id: 'rahalaitos.fi.creditCardLabel',
    defaultMessage: 'Do you have a credit card?',
    description: 'Asking customer if they have credit cards',
  },
  coApplicantCreditCardLabel: {
    id: 'rahalaitos.fi.coApplicantCreditCardLabel',
    defaultMessage: 'Does your co-applicant have a credit card?',
    description: 'Asking customer if the coApplicant have credit cards',
  },
  coApplicantOtherIncomeLabel: {
    id: 'rahalaitos.fi.coApplicantOtherIncomeLabel',
    defaultMessage: 'Does your co-applicant have any other income?',
    description: 'Asking if coApplicant has other income',
  },
  coApplicantGrossOtherIncomeLabel: {
    id: 'rahalaitos.fi.coApplicantGrossOtherIncomeLabel',
    defaultMessage: "Co-applicant's other income before tax (€/mth)",
    description: 'Asking customer what their other income before tax is',
  },
  coApplicantGrossOtherIncomePlaceholder: {
    id: 'rahalaitos.fi.coApplicantGrossOtherIncomePlaceholder',
    defaultMessage: 'X XXX',
    description: 'Asking customer what their other income before tax is',
  },
  coApplicantNetOtherIncomeLabel: {
    id: 'rahalaitos.fi.coApplicantNetOtherIncomeLabel',
    defaultMessage: "Co-applicant's other income after tax (€/mth)",
    description: 'Asking customer what their other income after tax is',
  },
  coApplicantNetOtherIncomePlaceholder: {
    id: 'rahalaitos.fi.coApplicantNetOtherIncomePlaceholder',
    defaultMessage: 'X XXX',
    description: 'Asking customer what their other income after tax is',
  },
  coApplicantOtherIncomeSourceLabel: {
    id: 'rahalaitos.fi.coApplicantOtherIncomeSourceLabel',
    defaultMessage: "Co-applicant's other income source",
    description: 'Asking customer what their other income after tax is',
  },
  coApplicantOtherIncomeSourcePlaceholder: {
    id: 'rahalaitos.fi.coApplicantOtherIncomeSourcePlaceholder',
    defaultMessage: 'E.g second job',
    description: 'Asking customer what their other income after tax is',
  },
  grossOtherIncomeLabel: {
    id: 'rahalaitos.fi.grossOtherIncomeLabel',
    defaultMessage: 'Other income before tax (€/mth)',
    description: 'Asking customer what their other income before tax is',
  },
  grossOtherIncomePlaceholder: {
    id: 'rahalaitos.fi.grossOtherIncomePlaceholder',
    defaultMessage: 'X XXX',
    description: 'Asking customer what their other income before tax is',
  },
  netOtherIncomeLabel: {
    id: 'rahalaitos.fi.netOtherIncomeLabel',
    defaultMessage: 'Other income after tax (€/mth)',
    description: 'Asking customer what their other income after tax is',
  },
  netOtherIncomePlaceholder: {
    id: 'rahalaitos.fi.netOtherIncomePlaceholder',
    defaultMessage: 'X XXX',
    description: 'Asking customer what their other income after tax is',
  },
  otherIncomeSourceLabel: {
    id: 'rahalaitos.fi.otherIncomeSourceLabel',
    defaultMessage: 'Other income source',
    description: 'Asking customer what their other income after tax is',
  },
  otherIncomeSourcePlaceholder: {
    id: 'rahalaitos.fi.otherIncomeSourcePlaceholder',
    defaultMessage: 'E.g second job',
    description: 'Asking customer what their other income after tax is',
  },
  businessIdLabel: {
    id: 'rahalaitos.fi.businessIdLabel',
    defaultMessage: 'Business ID',
    description: 'Label for Business ID field',
  },
  coApplicantBusinessIdLabel: {
    id: 'rahalaitos.fi.coApplicantBusinessIdLabel',
    defaultMessage: 'Business ID',
    description: 'Label for coApplicant field Business ID',
  },
  businessIdPlaceholder: {
    id: 'rahalaitos.fi.businessIdPlaceholder',
    defaultMessage: '1234567-8',
    description: 'Placeholder for Business ID field',
  },
  coApplicantBusinessIdPlaceholder: {
    id: 'rahalaitos.fi.coApplicantBusinessIdPlaceholder',
    defaultMessage: '1234567-8',
    description: 'Placeholder for coApplicant field Business ID',
  },
  civilStatusDivorced: {
    id: 'rahalaitos.fi.civilStatusDivorced',
    defaultMessage: 'Divorced',
    description: 'Button text for civil status divorced',
  },
  civilStatusWidow: {
    id: 'rahalaitos.fi.civilStatusWidow',
    defaultMessage: 'Widow',
    description: 'Button text for civil status widow',
  },
  acceptCreditCheck: {
    id: 'rahalaitos.fi.acceptCreditCheck',
    defaultMessage: "I give my consent to the transfer of data to credit providers in accordance with Suomen Asiakastieto Oy's survey system. <a>Read more</a>",
    description: 'Credit check acceptance message',
  },
  businessIDRequired: {
    id: 'rahalaitos.fi.businessIdIsEmpty',
    defaultMessage: 'Please enter your Business ID',
    description: '',
  },
  invalidBusinessIDFormat: {
    id: 'rahalaitos.fi.businessIdWrongFormat',
    defaultMessage: 'Please enter in format 123456-7',
    description: 'Error message informing the applicant that the business ID number is wrongly formatted',
  },
  acceptNewsletterConsentText: {
    id: 'rahalaitos.fi.acceptNewsletterConsentText',
    defaultMessage: 'I want to receive offers and information about the services and benefits of Rahalaitos and our partners by e-mail and text message.',
    description: 'Consent text for customers to agree to accept newsletter',
  },
  acceptAgreement: {
    id: 'rahalaitos.fi.acceptAgreement',
    defaultMessage: 'I accept the <a>user agreement</a> and confirm that I have read the <y>privacy policy</y>.',
    description: 'Consent text for customers to agree to accept agreement',
  },
  applyLabel: {
    id: 'rahalaitos.fi.applyLabel',
    defaultMessage: 'Compare loans',
    description: 'Button label for submit label',
  },
  continueLabel: {
    id: 'rahalaitos.fi.continueLabel',
    defaultMessage: 'Continue  ➔',
    description: 'Button label to continue to main form',
  },
  applicationSavedLabel: {
    id: 'rahalaitos.fi.applicationSavedLabel',
    defaultMessage: 'Your application has been saved.  Fill in the missing information and compete for loans quickly.',
    description: 'label for main form',
  },
  coApplicantLabel: {
    id: 'rahalaitos.fi.coApplicantLabel',
    defaultMessage: 'Please enter your co-applicant details',
    description: '',
  },
  loanResponsibilityLabel: {
    id: 'rahalaitos.fi.loanResponsibilityLabel',
    defaultMessage: 'Loan responsibility',
    description: 'Loan responsibility label',
  },
  otherLoansInfoMessage: {
    id: 'rahalaitos.fi.otherLoansInfoMessage',
    defaultMessage: 'Note that you will need to specify your total consolidation amount at the beginning of the application. ✓ By consolidating loans, you can get better interest rates.',
    description: 'Curren loans info message',
  },
  duplicateApplicationErrorMessage: {
    id: 'rahalaitos.fi.submitError.duplicateApplication',
    defaultMessage: 'It looks like you already have a valid application. You can find it by logging into your <a>user account</a>. If you want to make changes to the application, please contact our customer service on',
    description: 'Text for the error message that is displayed to the customer when they already have a active application.',
  },
  errorMessageTitle: {
    id: 'rahalaitos.fi.submitError.title',
    defaultMessage: 'Wops!',
    description: 'Title for the error that is displayed on submit.',
  },
  otherLivingCostLabel: {
    id: 'rahalaitos.fi.otherLivingCost.label',
    defaultMessage: 'Other living costs (€/mth)',
    description: 'otherLivingCost Label',
  },
  otherLivingCostTooltip: {
    id: 'rahalaitos.fi.otherLivingCostTooltip',
    defaultMessage: 'Please enter the monthly cost connected to your other living costs besides housing.',
    description: 'Tooltip-text för other living costs i formulär.',
  },
  coApplicantOtherLivingCostsLabel: {
    id: 'rahalaitos.fi.coApplicantOtherLivingCostsLabel',
    defaultMessage: "Co-applicant's other living costs (€/mth)",
    description: 'Label-text för other living costs i formulär.',
  },
  coApplicantOtherLivingCostsTooltip: {
    id: 'rahalaitos.fi.coApplicantOtherLivingCostsTooltip',
    defaultMessage: 'Please enter the monthly cost connected to your other living costs besides housing.',
    description: 'Tooltip for coApplicant other living cost field',
  },
  pCRText: {
    id: 'rahalaitos.fi.PCRText',
    defaultMessage: 'I am aware that the creditor can collect and process my credit and income information obtained from the positive credit register maintained by the Income Registry Unit of the Tax Administration. The creditor can use this information to process the loan application, assess creditworthiness and check that the information is up-to-date. The creditor can also report my credit information to the positive credit register.',
    description: 'Due to the implementation of PCR in FI we will have to “warn” customer about that.',
  },
  skipReapplyButton: {
    id: 'omalaina.fi.skipReapplyButton',
    defaultMessage: 'Proceed without fetching details',
    description: 'Text for skip reapply button',
  },
  reaplyButton: {
    id: 'omalaina.login.button',
    defaultMessage: 'Sign in with your bank',
    description: 'Knapptext för BankIDinloggningsknappen i inloggningsformuläret',
  },
  reaplyTitle: {
    id: 'omalaina.heading',
    defaultMessage: 'Have you applied with omalaina before?',
    description: 'Heading on the reapply slide',
  },
  reaplSsubtitle: {
    id: 'omalaina.subtitle',
    defaultMessage: 'If you are a returning customer we can fetch your previous details for you so you dont have to fill the form again',
    description: 'Subtitle for the reapply slide',
  },
  prefillTitle: {
    id: 'omalaina.prefillTitle',
    defaultMessage: 'You have an ongoing application!',
    description: 'Title for prefill',
  },
  prefillText1: {
    id: 'omalaina.prefillText1',
    defaultMessage: 'To speed up the process for you, you can retrieve the information that you have already filled in. For your security, we ask you to go through a strong identification process. You can identify yourself with bank credentials or a mobile identifier, and we will pre-fill your application with the information from your previous application.',
    description: 'text for prefill 1',
  },
  prefillText2: {
    id: 'omalaina.prefillText2',
    defaultMessage: 'To speed up the process, you can pre-fill your application with the information from the latest application form by strongly identifying yourself.',
    description: 'text for prefill 2',
  },
  prefillListItem1: {
    id: 'omalaina.prefillListItem1',
    defaultMessage: 'We check and secure your identity (Tarkistamme ja turvaamme henkilöllisyytesi)',
    description: 'prefillListItem1',
  },
  prefillListItem2: {
    id: 'omalaina.prefillListItem2',
    defaultMessage: 'We collect your previous information and pre-fill the application',
    description: 'prefillListItem2',
  },
  prefillHeadTitle: {
    id: 'omalaina.prefillHeadTitle',
    defaultMessage: 'Welcome Back!',
    description: 'welcome back title for prefil section',
  },
  personalDataHeadline: {
    id: 'rahalaitos.fi.PersonalData',
    defaultMessage: '1. Personal information',
    description: 'Headline For Personal Data',
  },
  housingContactDataHeadline: {
    id: 'rahalaitos.fi.HousingInformationHeadline',
    defaultMessage: '2. Housing & contact information',
    description: 'Headline For Housing and contact information',
  },
  educationWorkDataHeadline: {
    id: 'rahalaitos.fi.EducationWorkHeadline',
    defaultMessage: '3. Education & work',
    description: 'education and work information',
  },
  debtsDataHeadline: {
    id: 'rahalaitos.fi.DebtsHeadline',
    defaultMessage: '4. Debts & expenses (own share)',
    description: 'debts information',
  },
  bankDataHeadline: {
    id: 'rahalaitos.fi.BankDetailsHeadline',
    defaultMessage: '5. Bank details',
    description: 'bank details',
  },
  coApplicantDataHeadline: {
    id: 'rahalaitos.fi.CoApplicantsHeadline',
    defaultMessage: '6. Joint applicant',
    description: 'co applicant details',
  },
  acceptDataHeadline: {
    id: 'rahalaitos.fi.AcceptHeadline',
    defaultMessage: '7. Accept credit application',
    description: 'accept of aplication',
  },
  coAppPersonalDataHeadline: {
    id: 'rahalaitos.fi.CoAppPersonalData',
    defaultMessage: '6.1 Personal information of the joint applicant',
    description: 'Headline For CoApp Personal Data',
  },
  coAppHousingContactDataHeadline: {
    id: 'rahalaitos.fi.CoAppHousingInformationHeadline',
    defaultMessage: "6.2 Co-applicant's residence & contact information",
    description: 'Headline For Housing and contact information CoApp',
  },
  coAppEducationWorkDataHeadline: {
    id: 'rahalaitos.fi.CoAppEducationWorkHeadline',
    defaultMessage: "6.3 Joint applicant's work & education",
    description: 'education and work information CoApp',
  },
  coAppDebtsDataHeadline: {
    id: 'rahalaitos.fi.CoAppDebtsHeadline',
    defaultMessage: '6.4 Debts of the joint applicant (own share)',
    description: 'debts information',
  },
  coAppBankDataHeadline: {
    id: 'rahalaitos.fi.CoAppBankDetailsHeadline',
    defaultMessage: '5. Bank details',
    description: 'bank details',
  },
  coAppDebtBreakdownLabel: {
    id: 'rahalaitos.fi.coAppDebtBreakdownLabel',
    defaultMessage: '6.4 Current loans and refinancing',
    description: 'Label for removing a current loan',
  },
  clockBanner: {
    id: 'rahalaitos.fi.clockBanner',
    defaultMessage: 'Takes about 3–4 minutes to complete',
    description: 'the cklock banner',
  },
  yearONE: {
    id: 'rahalaitos.fi.yearONE',
    defaultMessage: '1 year',
    description: 'repayment time 1 year',
  },
  yearTWO: {
    id: 'rahalaitos.fi.yearTWO',
    defaultMessage: '2 years',
    description: 'repayment time 2 years',
  },
  yearTHREE: {
    id: 'rahalaitos.fi.yearThree',
    defaultMessage: '3 years',
    description: 'repayment time 3 years',
  },
  yearFOUR: {
    id: 'rahalaitos.fi.yearFOUR',
    defaultMessage: '4 years',
    description: 'repayment time 4 year',
  },
  yearFIVE: {
    id: 'rahalaitos.fi.yearFIVE',
    defaultMessage: '5 years',
    description: 'repayment time 5 years',
  },
  yearSIX: {
    id: 'rahalaitos.fi.yearSIX',
    defaultMessage: '6 years',
    description: 'repayment time 6 years',
  },
  yearSEVEN: {
    id: 'rahalaitos.fi.yearSEVEN',
    defaultMessage: '7 years',
    description: 'repayment time 7 year',
  },
  yearEIGHT: {
    id: 'rahalaitos.fi.yearEIGHT',
    defaultMessage: '8 years',
    description: 'repayment time 8 years',
  },
  yearNINE: {
    id: 'rahalaitos.fi.yearNINE',
    defaultMessage: '9 years',
    description: 'repayment time 9 years',
  },
  yearTEN: {
    id: 'rahalaitos.fi.yearTEN',
    defaultMessage: '10 years',
    description: 'repayment time 10 year',
  },
  yearELEVEN: {
    id: 'rahalaitos.fi.yearELEVEN',
    defaultMessage: '11 years',
    description: 'repayment time 11 years',
  },
  yearTWELVE: {
    id: 'rahalaitos.fi.yearTWELVE',
    defaultMessage: '12 years',
    description: 'repayment time 12 years',
  },
  yearTHIRTEEN: {
    id: 'rahalaitos.fi.yearTHIRTEEN',
    defaultMessage: '13 years',
    description: 'repayment time 13 year',
  },
  yearFOURTEEN: {
    id: 'rahalaitos.fi.yearFOURTEEN',
    defaultMessage: '14 years',
    description: 'repayment time 14 years',
  },
  yearFIVETEEN: {
    id: 'rahalaitos.fi.yearFIVETEEN',
    defaultMessage: '15 years',
    description: 'repayment time 15 years',
  },
  yearSIXTEEN: {
    id: 'rahalaitos.fi.yearSIXTEEN',
    defaultMessage: '16 years',
    description: 'repayment time 16 year',
  },
  yearSEVENTEEN: {
    id: 'rahalaitos.fi.yearSEVENTEEN',
    defaultMessage: '17 years',
    description: 'repayment time 17 years',
  },
  yearEIGHTTEEN: {
    id: 'rahalaitos.fi.yearEIGHTTEEN',
    defaultMessage: '18 years',
    description: 'repayment time 18 years',
  },
  yearNINETEEN: {
    id: 'rahalaitos.fi.yearNINETEEN',
    defaultMessage: '19 years',
    description: 'repayment time 19 years',
  },
  yearTWENTY: {
    id: 'rahalaitos.fi.yearTWENTY',
    defaultMessage: '20  years',
    description: 'repayment time 20 years',
  },
});

export default messages;
